import React, { Component } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { Button, IconButton } from "@mui/material";
import { FormControl } from "@mui/material";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import settings from "../helpers/Settings";
import Row from "react-bootstrap/Row";
import Cookies from "js-cookie";
import Col from "react-bootstrap/Col";
import axios from "axios";
import { Box } from "@mui/material";
import * as moment from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { CSVLink } from "react-csv";
import VisibilityIcon from "@mui/icons-material/Visibility";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import InputLabel from "@mui/material/InputLabel";
import Select, { selectClasses } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Accordion from "react-bootstrap/Accordion";
import Checkbox from "@mui/material/Checkbox";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import Autocomplete from "./AutoCompleteComponent/AutoComplete";
import AutoComplete from "@mui/material/Autocomplete";
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import { Multiselect } from "multiselect-react-dropdown";
import { Diversity1Outlined } from "@mui/icons-material";
import ReplyIcon from '@mui/icons-material/Reply';
import CircularProgress from "@mui/material/CircularProgress";
let { KayanURL } = settings;
const styleModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  bgcolor: "background.paper",
  borderRadius: "20px",
  p: 4,
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid gray",
  borderRadius: "20px",
  boxShadow: 24,
  p: 4,
};
const allTPA = {
  7001463160: "GlobeMed Saudi",
  7001580856: "Nextcare",
  7001604342: "Mednet",
  7001599658: "Totalcare"
}
const allInsuraceCompanies = {
  "INS-FHIR": "Pseudo Payer",
  7001571327: "Bupa Arabia for Cooperative Insurance",
  7000911508: "The Cooperative Company for Cooperative Insurance",
  7001593321: "Al-Rajhi Company for Cooperative Insurance",
  7001548317:
    "The Mediterranean and Gulf Cooperative Insurance and Reinsurance Company (MedGulf)",
  7001539720: "Saudi Arabian Cooperative Insurance Company (SAICO) *",
  7001532279: "Gulf Union Cooperative Insurance Company",
  7001607683: "AXA Cooperative Insurance Company",
  7001519912: "Malath Cooperative Insurance and Reinsurance Company",
  7001559389: "United Cooperative Insurance Company",
  7001727200: "Tokyo Marine Development Corporation",
  7001527816: "Arabian Shield Cooperative Insurance Company *",
  7001617724: "Buruj Cooperative Insurance Company *",
  7001549059: "Trade Union Cooperative Insurance Company *",
  7001544472: "Al Sagr Cooperative Insurance Company *",
  7001641419: "Gulf General Company for Cooperative Insurance",
  7001609481: "Global Company for Cooperative Insurance",
  7001535694: "Allied Cooperative Insurance Group (ACIG)",
  7001526578: "Saudi United Cooperative Insurance Company (Wala",
  7001537161: "Allianz Saudi Fransi Cooperative Insurance Company",
  7001534275: "The National Company for Cooperative Insurance",
  7001626717: "Amana Cooperative Insurance Company *",
  7001625891: "Solidarity Saudi Takaful Company",
  7001703672: "Saudi Enaya Cooperative Insurance Company",
  7001523724: "Salama Cooperative Insurance Company",
  7001527667: "Arabia Insurance Cooperative Company",
};
class ClaimSubmission extends Component {
  constructor(props) {
    super(props);
    this.fileInputRef = React.createRef();
    this.state = {
      requestsFound: false,
      approvalInfoExist: false,
      defaultpayerIdValue: "",
      claims: [],
      batchSubmissionFlag: false,
      checkboxFlag: false,
      editClaim: false,
      procedureQuantity: 1,
      procedureShare: 0,
      serviceValue: "",
      autoValue: "",
      allDiagnosisSelect: [],
      vitalSignsArray: [],
      vitalSignSelectArray: [],
      calimDefaultValue: "",
      searchInfo: {},
      batchInfo: {},
      pollLoading: false,
      queuedFlag: false,
      submitLoading: false,
      claimSeq: [],
      procedureSeq: [],
      checkAll: false,
      batchLoading: false,
      key: 0,
      Claimskey: 0,
      procedures: [],
      pollCommLoading: false


    };
  }
  componentDidMount = async () => {
    let nphiesID = localStorage.getItem("nphies-id");
    this.setState({ nphiesID });
    this.getAllVisits();
  };
  getAllCommRequestInfo = async () => {
    let {allClaimsInfo} =this.state;
    let result = await axios.put(
      KayanURL + "api/KSA/RCM/patient/getAllCommunicationRequest",
      {
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
      }
    );
    if (result) {
      let { data } = result;
      if (data) {
        let { allCommRequest } = data;
        if (data.success) {
          console.log(data.allCommRequest, 'commm for map')
          if (allCommRequest && allCommRequest.length > 0) {
            if (allClaimsInfo && allClaimsInfo.length > 0) {
              for (let i = 0; i < allClaimsInfo.length; i++) {
                let obj = allCommRequest.find(
                  (e) => e.communicationabout === allClaimsInfo[i].claimrequestidentifier
                );
                if (obj) {
                  this.setState({ commRequestExist: true })
                }else{
                  this.setState({ commRequestExist: false })
                }
              }
            }
          }
          this.setState({
            success: true,
            allCommRequestInfo: data.allCommRequest,
          });
        } else {
          this.setState({
            success: false,
            error: data.error,
          });
        }
      }
    }
  };
  getAllClaimInfo = async () => {
    let result = await axios.put(
      KayanURL + "api/KSA/RCM/ClaimSubmission/getClaimInfo",
      {
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
      }
    );
    if (result) {

      let { data } = result;
      if (data) {
        if (data.success) {
          console.log(data.claimInfo, 'commm for map')
          this.setState({
            success: true,
            allClaimsInfo: data.claimInfo,
          });
          this.getAllCommRequestInfo();
        } else {
          this.setState({
            success: false,
            error: data.error,
          });
        }
      }
    }
  };
  showCoverage = async (coverage) => {
    if (coverage && coverage.length > 0) {
      this.setState({
        showCoverageInfo: true,
        memberid: coverage[0].memberid,
        network: coverage[0].network,
        coverageType: coverage[0]["coverage-type"],
        term: coverage[0].period.start + " to " + coverage[0].period.end,
        subscriberRelationship: coverage[0]["subscriber-relationship"],
        costToBeneficiaryTypesValues: coverage[0].paymentDetails,
      });
      let classRows;
      if (coverage[0].class && coverage[0].class.length > 0) {
        classRows = coverage[0].class.map((element, index) => {
          return (
            <TableRow key={index}>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.type}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.name}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.value}
              </TableCell>
            </TableRow>
          );
        });
        this.setState({ classRows });
      }
    }
  };
  handleCloseCoverageInfoModal = () => {
    this.setState({ showCoverageInfo: false });
  };
  handlePollingRequest = async () => {
    this.setState({ pollLoading: true })
    let result = await axios.post(
      "http://141.147.130.248:4000/api/KSA/RCM/request",
      {
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),

        requestType: "5",

        providerName: localStorage.getItem("nphies-provider-name"),
        providerID: localStorage.getItem("nphies-id"),
        include: "priorauth-response",
        returnFullResponse: false,
        /*  testing: true, */
      }
    );

    if (result) {
      setTimeout(() => {
        this.setState({ pollLoading: false });
      }, 500);
      let { data } = result;

      let { success, responses, error, BundleID } = data;

      if (success) {
        if (responses && responses.length > 0 /*  || 1 */) {
          for (let i = 0; i < responses.length; i++) {
            let claimResponse = responses[i];

            let {
              ResponseBuisnessIdentifier,
              outcome,
              requestIdentifier,
              items,
              adjudicationOutcome,
              Total,
              errors
            } = claimResponse;

            if (outcome === "complete") {
              await this.handleAddClaimResponse(
                items,
                Total,
                ResponseBuisnessIdentifier,
                BundleID,
                adjudicationOutcome,
                outcome,
                requestIdentifier,
                "",
                []
              );
            } else if (outcome === "error") {
              await this.handleAddClaimResponse(
                [],
                [],
                ResponseBuisnessIdentifier,
                BundleID,
                "",
                outcome,
                requestIdentifier,
                "",
                errors,
              )
            } else if (outcome === "queued") {
              await this.handleAddClaimResponse(
                [],
                [],
                ResponseBuisnessIdentifier,
                BundleID,
                "",
                outcome,
                requestIdentifier,
                "",
                []
              )
            }
            // this.setState({updateVisit:true})
          }
          this.getAllVisits();

        }
      } else {
        console.log("error in polling");
        console.log(error);
        console.log("----------");
      }

      /*   if (data) {
        this.setState({ requestsFound: true });
        if (data.success) {
          this.setState({ success: true, allvisits: data.visits });
        } else {
          this.setState({
            success: false,
            error: data.error,
            searchInfo: {},
            allvisits: data.visits,
          });
        }
      } */
    }
  };
  handleSave = async (e) => {
    e.preventDefault();
    let { selectedVisit, editClaim} = this.state;
    //  console.log(selectedVisit.originProcedures,'origin')
    //  console.log(selectedVisit.allprocedures,'finall')
    let Finalprocedures
     let {originProcedures,allprocedures}=selectedVisit;
     if(originProcedures && originProcedures.length>0){
      allprocedures.forEach(item2 => {
        // Find the corresponding item in a1
        let item1 = originProcedures.find(item => item.code === item2.code);
        if (item1) {
            // Update properties in item1 based on item2
            Object.keys(item2).forEach(key => {
                item1[key] = item2[key];
            });
        }
    });
    Finalprocedures = selectedVisit["originProcedures"]
     }else{
      Finalprocedures = selectedVisit["allprocedures"]
     }
     
    if (editClaim) {
      this.setState({ saveLoading: true, addVital: false })
      let Response = await axios.post(
        KayanURL + "api/KSA/RCM/patient/addForNeed",
        {
          id: selectedVisit.id,
          claimType: selectedVisit.claimtype,
          diagnosis: JSON.stringify(selectedVisit["diagnosis"]),
          allProcedures: JSON.stringify(Finalprocedures),
          proceduresNeedAproval: JSON.stringify(Finalprocedures),
          supportingInformation: JSON.stringify(
            selectedVisit["supportinginformation"]
          ),
          visitStatus: "4",
          startDateVisit: selectedVisit.visitstartdate,
          isNeedSubmission: true,
          isNeedApproval: true,
          claimSubmissionStatus: selectedVisit.claimsubmissionstatus,
          authorizationStatus: selectedVisit.authorizationstatus,
          endVisitDate: selectedVisit.visitenddate,
          apiToken: Cookies.get("RCM_KSA_Employee_Token"),
        }
      );
      if (Response) {
        setTimeout(() => {
          this.setState({ saveLoading: false });
        }, 1000);
        let { data } = Response;
        if (data) {
          if (data.success) {
            this.setState({
              success: true,
              editClaim: false,
              updateVisit: true,
            });

            await this.getAllVisits();
            //  if(claims && claims.length >0){
            //   claims.forEach(e => {
            //     const index = allvisits.findIndex(item => item["id"] === e["visitNumber"]);
            //     claimSeq.push(index)
            //   })
            //   this.setState({claimSeq})
            //  }
            //   console.log(claimSeq,'after save')

          } else {
            this.setState({ success: false, error: data.error });
          }
        }

      }
    }
  };
  getAllClaimInformation = async (visit,flag) => {
    this.setState({
      selectedVisit: visit,
      viewClaimSubmissionInfoModal: flag?false:true,
      claimSubmissionItemsRows: [],
      errorsRow: [],
      queuedInfoRows: {},
      queuedFlag: false,
      AuthQueuedInfo: {},

    });

    const year = new Date().getFullYear();
    const dateSplit = visit.birthdate.split("-");
    const birthYear = dateSplit[0];
    const age = year - birthYear;

    visit["age"] = age;
    let { doctorid } = visit;
    if (doctorid) {
      let doctor = await this.getDoctorByID(doctorid);

      if (doctor && doctor.length > 0) {
        doctor = doctor[0];
        let { name } = doctor;
        visit["doctorName"] = name;
      }
    }
    let { vitalSignSelectArray } = this.state;
    if (
      visit.supportinginformation &&
      visit.supportinginformation.length > 0 && vitalSignSelectArray.length == 0
    ) {
      let categories = visit.supportinginformation;
      for (let i = 0; i < categories.length; i++) {
        let display = Object.keys(categories[i]);
        console.log(display)
        let valueInfo = Object.values(categories[i]);
        if (display[0] === "chief-complaint") {
          valueInfo = Object.values(categories[i])[0].text
        } else if (display[0] === "attachment") {
          valueInfo = Object.values(categories[i])[0].title
        }
        console.log(valueInfo)
        vitalSignSelectArray.push({
          display: display[0] + " " + valueInfo,
          valueInfo: valueInfo,
        });
      }
      // console.log(vitalSignSelectArray, 'hoooooon')
    }
    if (visit.authorizationstatus !== null) {
      //get the claim authorization info
      this.setState({
        approvalInfoExist: true,
      });

      let getApprovalInfo = await axios.put(
        KayanURL + "api/KSA/RCM/patient/getAllAuthInfoByVisitID",
        {
          apiToken: Cookies.get("RCM_KSA_Employee_Token"),
          visitId: visit.id,
        }
      );

      if (getApprovalInfo) {
        let { data } = getApprovalInfo;
        if (data.success) {
          let { AllApproval } = data;

          if (AllApproval && AllApproval.length > 0) {
            if (AllApproval.length == 1) {
              let { adjucationoutcome, items, totals, preauthperiod,
                preauthref, authorizationresponseoutcome, authorizationrequestidentifier, authorizationresponseidentifier, authorizationrequestbundleid
              } = AllApproval[0];
              if (authorizationresponseoutcome === "complete") {
                visit["preAuthRef"] = preauthref;
                visit["preAuthPeriod"] = preauthperiod;
                visit["Authtotals"] = totals;
                visit["authorizationrequestidentifier"] = authorizationrequestidentifier;
                visit["authorizationresponseidentifier"] = authorizationresponseidentifier;
                visit["approvalAdudicationOutcome"] = adjucationoutcome;

                let { allprocedures } = visit;

                let { procedureSeq, procedures } = this.state
                if (allprocedures && allprocedures.length > 0 && items && items.length > 0) {
                  allprocedures.forEach((procedure, index) => {
                    let { outcome, reason, denailCode, adjudications } = items[index];
                    if (outcome === "approved" || outcome === "partial") {
                      procedures.push(procedure)
                      procedureSeq.push(index + 1)
                      this.setState({ procedureSeq, procedures })
                    }
                    procedure["outcome"] = outcome;
                    procedure["reason"] = reason;
                    procedure["denailCode"] = denailCode;
                    procedure["adjudications"] = adjudications;
                  });
                }
                visit["allprocedures"] = allprocedures;
              } else if (authorizationresponseoutcome === "queued") {
                console.log("queued", AllApproval);
                visit["authorizationrequestidentifier"] = authorizationrequestidentifier;
                visit["authorizationresponseidentifier"] = authorizationresponseidentifier;
                this.setState({
                  AuthQueuedInfo: {
                    outcome: authorizationresponseoutcome,
                    bundleID: authorizationrequestbundleid,
                    requestIdentifier:
                      authorizationrequestidentifier,
                    preAuthResponseIdentifier:
                      authorizationresponseidentifier,
                  },
                });
              }


            } else {
              AllApproval.sort((a, b) => a.id - b.id);
              AllApproval = AllApproval[AllApproval.length - 1];
              console.log(AllApproval, 'allApp after')
              // let AllAprovalForResubmission = [];
              // let ApprovalForResubmission = AllApproval;
              let proceduress = []
              let {
                authorizationresponseoutcome,
                authorizationrequestidentifier,
                authorizationresponseidentifier,
                authorizationrequestbundleid,
                preauthperiod,
                preauthref,
                totals,
                proceduresequenses
              } = AllApproval;

              let { allprocedures } = visit;
                  visit["originProcedures"]=allprocedures;
              if (proceduresequenses && proceduresequenses.length > 0) {
                for (let i = 0; i < proceduresequenses.length; i++) {
                  let index = proceduresequenses[i] - 1;
                  proceduress.push(allprocedures[index])
                }
                visit["allprocedures"] = proceduress;
                // console.log(visit["allprocedures"],'llllllll');
              }
              if (authorizationresponseoutcome === "complete") {
                let { procedures, procedureSeq } = this.state

                visit["preAuthRef"] = preauthref;
                visit["preAuthPeriod"] = preauthperiod;
                visit["Authtotals"] = totals;
                visit["authorizationrequestidentifier"] = authorizationrequestidentifier;
                let { items, adjucationoutcome } = AllApproval;
                visit["approvalAdudicationOutcome"] = adjucationoutcome;
                // procedures["approvalAdudicationOutcome"] = adjucationoutcome;
                visit["authorizationresponseidentifier"] = authorizationresponseidentifier;

                // console.log(allprocedures,'allproced',items,'111')
                if (visit["allprocedures"] && visit["allprocedures"].length > 0 && items && items.length > 0) {
                  visit["allprocedures"].forEach((procedure, index) => {
                    let { outcome, reason, denailCode, adjudications } = items[index];
                    if (outcome === "approved" || outcome === "partial") {
                      procedures.push(procedure)
                      procedureSeq.push(index + 1)
                      this.setState({ procedureSeq, procedures })
                    }
                    procedure["outcome"] = outcome;
                    procedure["reason"] = reason;
                    procedure["denailCode"] = denailCode;
                    procedure["adjudications"] = adjudications;
                  });
                }
                visit["allprocedures"] = visit["allprocedures"];

               

              } else if (authorizationresponseoutcome === "queued") {
                console.log("queued", AllApproval);
                visit["authorizationrequestidentifier"] = authorizationrequestidentifier;
                visit["authorizationresponseidentifier"] = authorizationresponseidentifier;
                this.setState({
                  AuthQueuedInfo: {
                    outcome: AllApproval.authorizationresponseoutcome,
                    bundleID: AllApproval.authorizationrequestbundleid,
                    requestIdentifier:
                      AllApproval.authorizationrequestidentifier,
                    preAuthResponseIdentifier:
                      AllApproval.authorizationresponseidentifier,
                  },
                });
              }
              //  else if (authorizationresponseoutcome === "error") {

              //   let { autherror } = AllApproval[i];
              //   if (autherror && autherror.length > 0) {
              //     const errorsRow = autherror.map((element, index) => {
              //       return (
              //         <TableRow key={index}>
              //           <TableCell align="center" style={{ fontSize: "small" }}>
              //             {element.code}
              //           </TableCell>
              //           <TableCell align="center" style={{ fontSize: "small" }}>
              //             {element.display}
              //           </TableCell>
              //           <TableCell align="center" style={{ fontSize: "small" }}>
              //             {element.extension}
              //           </TableCell>
              //         </TableRow>
              //       );
              //     });
              //     ApprovalForResubmission["errorsRow"] = errorsRow;
              //     // this.setState({ errorsRow });
              //   }
              // } else if (authorizationresponseoutcome === "queued") {
              //   console.log("queued", ApprovalInfo);

              //   ApprovalForResubmission["queuedInfo"] = {
              //     outcome: authorizationresponseoutcome,
              //     bundleID: authorizationrequestbundleid,
              //     requestIdentifier: authorizationrequestidentifier,
              //     preAuthResponseIdentifier: authorizationresponseidentifier,

              //   };
              // }
              // AllAprovalForResubmission.push(ApprovalForResubmission);
            }

            // console.log(AllAprovalForResubmission, 'allResub')

            this.setState({ selectedVisit: visit })

          }


        }
      }
    } else {
      this.setState({
        approvalInfoExist: false,
      });
    }
    let claimsInfo = await axios.put(
      KayanURL + "api/KSA/RCM/ClaimSubmission/getAllClaim",
      {
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
        visitId: visit.id,
      }
    );
    if (claimsInfo) {
      let { data } = claimsInfo
      if (data.success) {
        let { AllClaims } = data
        if (AllClaims && AllClaims.length > 0) {
          console.log(AllClaims, 'allClaim')
          let { claimresponseoutcome, adjucationoutcome, claimrequestbundleid, claimresponseidentifier, items, claimrequestidentifier, totals } = AllClaims[0]
          visit["claimrequestidentifier"] =
            claimrequestidentifier;
          visit["claimresponseoutcome"] = claimresponseoutcome;
          visit["claimresponseidentifier"] =
            claimresponseidentifier;
          if (claimresponseoutcome == "complete") {
            // visit["claimsubmissionstatus"] = "3";
            visit["SubmissionAdjudicationOutcome"] = adjucationoutcome;
            visit["claimResponseIdentifier"] = claimresponseidentifier;
            visit["totals"] = totals;


            if (items && items.length > 0) {
              let { allprocedures } = visit;
              items.forEach((item, index) => {
                let { outcome, adjudications } = item;
                allprocedures[index]["claimSubmissionOutcome"] = outcome;
                allprocedures[index]["claimSubmissionAdjudications"] =
                  adjudications;
              });

              visit["allprocedures"] = allprocedures;
            }
          }
          else if (claimresponseoutcome === "error") {


            let { claimerror } = AllClaims[0];
            if (claimerror && claimerror.length > 0) {
              const errorsRow = claimerror.map((element, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell align="center" style={{ fontSize: "small" }}>
                      {element.code}
                    </TableCell>
                    <TableCell align="center" style={{ fontSize: "small" }}>
                      {element.display}
                    </TableCell>
                    <TableCell align="center" style={{ fontSize: "small" }}>
                      {element.extension}
                    </TableCell>
                  </TableRow>
                );
              });
              this.setState({
                errorsRow,
              });
            }
          }
          else if (claimresponseoutcome === "queued") {
            this.setState({
              queuedFlag: true,
              queuedInfo: {
                outcome: claimresponseoutcome,
                bundleID: claimrequestbundleid,
                requestIdentifier:
                  claimrequestidentifier,
                claimResponseIdentifier:
                  claimresponseidentifier,
              },
            });
          }

        }
      }
    }
    if (visit.selectedinsurance && visit.selectedinsurance.length > 0) {
      let itemHeader = [
        { label: "BenefitType", key: "benefitType" },
        { label: "AllowedMoney", key: "allowedMoney" },
        { label: "Category", key: "category" },
        { label: "Description", key: "description" },
        { label: "Name", key: "name" },
        { label: "Network", key: "network" },
        { label: "Term", key: "term" },
        { label: "Unit", key: "unit" },
      ];
      let TableOfBenefitsForView = [];
      let arr = [];
      let itemsOfInsurance;
      TableOfBenefitsForView = visit.selectedinsurance.map((ins, index) => {
        itemsOfInsurance = ins.items;
        this.setState({ itemsOfInsurance });
        let insItems = [];
        if (itemsOfInsurance && itemsOfInsurance.length > 0) {
          for (let i = 0; i < itemsOfInsurance.length; i++) {
            insItems.push({
              benefitType: itemsOfInsurance[i].benefitType,
              allowedMoney: itemsOfInsurance[i].allowedMoney,
              category: itemsOfInsurance[i].category,
              description: itemsOfInsurance[i].description,
              name: itemsOfInsurance[i].name,
              network: itemsOfInsurance[i].network,
              term: itemsOfInsurance[i].term,
              unit: itemsOfInsurance[i].unit,
            });
          }
          arr.push(insItems);
        }

        let id = index + 1;
        let siteEligibility = ins.siteEligibility;
        return (
          <TableRow key={index}>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {id}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {siteEligibility}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {ins.Inforce ? "True" : "False"}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              <a
                onClick={(e) => {
                  this.showCoverage(ins["coverage"]);
                }}
                style={{ cursor: "pointer" }}
              >
                <VisibilityIcon style={{ color: "#6262e7" }} />
              </a>
            </TableCell>
            {itemsOfInsurance && itemsOfInsurance.length > 0 ? (
              <TableCell align="center" style={{ fontSize: "small" }}>
                <CSVLink
                  filename="report.csv"
                  data={arr[index]}
                  headers={itemHeader}
                >
                  <FileDownloadIcon />
                </CSVLink>
              </TableCell>
            ) : null}
          </TableRow>
        );
      });
      this.setState({ TableOfBenefitsForView });
    }
    this.setState({ selectedVisit: visit })


  };
  getAllVisits = async () => {
    let result = await axios.put(
      KayanURL + "api/KSA/RCM/ClaimSubmission/getAllVisists",
      {
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
      }
    );
    if (result) {
      let { data } = result;
      if (data) {
        if (data.success) {
          this.getAllClaimInfo();
          this.setState({
            success: true,
            allvisits: data.visits,
            requestsFound: false,
          });
          return data.visits
        } else {
          this.setState({
            success: false,
            error: data.error,
            allvisits: data.visits,
          });
        }
      }
    }
    this.setState((prevState) => ({
      Claimskey: prevState.Claimskey + 1
    }));
  };
  getDoctorByID = async (id) => {
    let result = await axios.put(
      KayanURL + "api/KSA/RCM/employee/getDoctorByID",
      {
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
        doctorID: id,
      }
    );
    if (result) {
      let { data } = result;
      if (data) {
        let { doctor } = data;
        // if (data.success) {
        return doctor;
        // }
      }
    }
  };
  ClaimSubmissionRequest = async (e, visit) => {
    e.preventDefault();

    let { procedures } = this.state
   let flag = false

    if (procedures && procedures.length > 0) {
      this.setState({ submissionError: "" })
    }
    let checkInvoice = false
    procedures.forEach(element => {
      if (!element.invoice) {

        checkInvoice = true
        this.setState({ invoiceMsg: "Invoice Number is required !" })

      }
    })
    if (!checkInvoice) {
      this.setState({ submitLoading: true, invoiceMsg: "", })
      let coverageInfo;
      let doctor = [];
      let doctorLastName = "";
      let doctorName;
      if (visit.doctorid) {
        doctor = await this.getDoctorByID(visit.doctorid);
        doctorName = doctor[0]["name"].split(" ");
        for (let i = 1; i < doctorName.length; i++) {
          doctorLastName += doctorName[i] + " ";
        }
      }
      if (visit.selectedinsurance && visit.selectedinsurance.length > 0) {
        let { coverage } = visit.selectedinsurance[0];
        let { paymentDetails } = coverage[0];
        let cost = [];
        for (let i = 0; i < paymentDetails.length; i++) {
          let keys = Object.keys(paymentDetails[i]);
          if (keys[0] === "spvisit") {
            let valueOfKey = paymentDetails[i][keys];
            cost.push({ [keys]: valueOfKey.toString() });
          } else {
            let valueOfKey = paymentDetails[i][keys].split(" ")[0];
            cost.push({ [keys]: valueOfKey });
          }
        }
        coverageInfo = {
          class: coverage[0].class,
          "coverage-type": coverage[0]["coverage-type"],
          memberid: coverage[0].memberid,
          network: coverage[0].network,
          period: coverage[0].period,
          "subscriber-relationship": coverage[0]["subscriber-relationship"],
          paymentDetails: cost,
        };
      }


      this.setState({
        authRequestSent: true,
        authResponse: false,
      });
      let CheckAuthorizationResponse
      if (visit.authorizationstatus === "4" || visit.authorizationstatus === "2" ||
        visit.authorizationstatus === "1" || visit.authorizationstatus === "cancelled") {
        CheckAuthorizationResponse = await axios.post(
          "http://141.147.130.248:4000/api/KSA/RCM/request",
          {
            apiToken: "token",
            requestType: "3",
            payerID: visit.payerid ? visit.payerid : "",
            TPA: visit.tpa ? visit.tpa : "",
            payerName: visit.payername,
            providerName: localStorage.getItem("nphies-provider-name"),
            providerID: localStorage.getItem("nphies-id"),
            providerType:1,
            priority:"deferred",
            patient: {
              ID: visit.identifier,
              identifierType: visit["identifiertype"],
              firstName: visit["firstname"],
              lastName: visit["lastname"],
              phone: visit["phone"],
              gender: visit["gender"],
              birthDate: visit["birthdate"],
              nationality: visit["nationality"],
               maritalStatus: "U",
        occupation: "business"
            },
           
            doctor: {
              firstName: doctorName[0],
              lastName: doctorLastName,
              practiceCode: doctor[0].doctor_practice_code,
              license: doctor[0].doctor_license,
            },

            /* supportingInformation: visit.supportinginformation, */
            supportingInformation:/*  visit.supportinginformation */  [
              {
                  "reason-for-visit": "new-visit"
              },
              {
                  "vital-sign-systolic": "100"
              },
              {
                  "vital-sign-diastolic": "60"
              },
              {
                  "vital-sign-height": "160"
              },
              {
                  "vital-sign-weight": "60"
              },
              {
                  "pulse": "85"
              },
              {
                  "respiratory-rate": "15"
              },
              {
                  "chief-complaint": {
                      "text": "LOWER ABDOMINAL PAIN, LOSS OF WEIGHT  6 KG, LOSS OF APPETITE, ALTERNATIVE DIARRHEA AND CONSTIPATION, ABDOMINAL DISCOMFORT, FLATULENCE,  BACK PAIN, HEART BURN AFTER EATING, AGGREVATED BY RECUMBENCY, RELIEVED WITH SITTING, ASSOCITED WITH ACID REGURGITATION",
                      "ICD": "A00.0"
                  }
              },
              {
                  "temperature": "37.5"
              },
              {
                  "estimated-Length-of-Stay": 2
              },
              {
                  "oxygen-saturation": "5"
              },
              {
                  "investigation-result": "INP"
              },
              {
                  "treatment-plan": "Appendectomy"
              },
              {
                  "patient-history": "No systemic disease"
              },
              {
                  "physical-examination": "Stable"
              },
              {
                  "history-of-present-illness": "No history"
              }
          ],
            claimType: visit.claimtype,
            diagnosis: visit.diagnosis,
            procedures: procedures,
            testing: visit.payerid ===
              "INS-FHIR"
              ? true
              : false,
            claimSubType: "op",
            codingSystem: "internal",
            visitNumber: "1223654",
            coverage: coverageInfo,
            preAuthOfflineDate: this.state.preAuthOfflineDate,
            eligibilityOfflineDate: this.state.eligibilityOfflineDate,
            EligibilityResponseIdentifier: visit.eligibilityresponseidentifie,
            EligibilityOnline: this.state.elegibilityOnline,
            EligibilityOffline: this.state.elegibilityOffline,
            returnFullResponse: false,
            "encounter": {
              "ID": "123456",
              "status": "finished",
              "class": {
                "code": "AMB",
                "display": "Ambulatory"
              },
              "admitSource": "WKIN",
              "serviceEventType": "ICSE",
              "period": {
                "start": "2024-07-11T10:25:00+03:00",
               // "end": "2024-07-13T10:25:00+03:00"
              },
              "serviceProvider": {
                "ID": "10000300178702",
                "name": "Faraby"
              },
              "patientID": "2013456789"
            }
          }
        );
      } else {
        CheckAuthorizationResponse = await axios.post(
          "http://141.147.130.248:4000/api/KSA/RCM/request",
          {
            apiToken: "token",
            requestType: "3",
            payerID: visit.payerid ? visit.payerid : "",
            TPA: visit.tpa ? visit.tpa : "",
            payerName: visit.payername,
            providerName: localStorage.getItem("nphies-provider-name"),
            providerID: localStorage.getItem("nphies-id"),
            providerType:1,
            "priority": "deferred",

            patient: {
              ID: visit.identifier,
              identifierType: visit["identifiertype"],
              firstName: visit["firstname"],
              lastName: visit["lastname"],
              phone: visit["phone"],
              gender: visit["gender"],
              birthDate: visit["birthdate"],
              nationality: visit["nationality"],
               maritalStatus: "U",
        occupation: "business"
            },
            doctor: {
              firstName: doctorName[0],
              lastName: doctorLastName,
              practiceCode: doctor[0].doctor_practice_code,
              license: doctor[0].doctor_license,
            },

          /*   supportingInformation: visit.supportinginformation, */
          supportingInformation:/*  visit.supportinginformation */  [
            {
                "reason-for-visit": "new-visit"
            },
            {
                "vital-sign-systolic": "100"
            },
            {
                "vital-sign-diastolic": "60"
            },
            {
                "vital-sign-height": "160"
            },
            {
                "vital-sign-weight": "60"
            },
            {
                "pulse": "85"
            },
            {
                "respiratory-rate": "15"
            },
            {
                "chief-complaint": {
                    "text": "LOWER ABDOMINAL PAIN, LOSS OF WEIGHT  6 KG, LOSS OF APPETITE, ALTERNATIVE DIARRHEA AND CONSTIPATION, ABDOMINAL DISCOMFORT, FLATULENCE,  BACK PAIN, HEART BURN AFTER EATING, AGGREVATED BY RECUMBENCY, RELIEVED WITH SITTING, ASSOCITED WITH ACID REGURGITATION",
                    "ICD": "A00.0"
                }
            },
            {
                "temperature": "37.5"
            },
            {
                "estimated-Length-of-Stay": 2
            },
            {
                "oxygen-saturation": "5"
            },
            {
                "investigation-result": "INP"
            },
            {
                "treatment-plan": "Appendectomy"
            },
            {
                "patient-history": "No systemic disease"
            },
            {
                "physical-examination": "Stable"
            },
            {
                "history-of-present-illness": "No history"
            }
        ],
            claimType: visit.claimtype,
            diagnosis: visit.diagnosis,
            procedures: procedures,
            testing: visit.payerid ===
              "INS-FHIR"
              ? true
              : false,
            claimSubType: "op",
            codingSystem: "internal",
            visitNumber: "1223654",
            coverage: coverageInfo,
            preAuthOfflineDate: this.state.preAuthOfflineDate,
            eligibilityOfflineDate: this.state.eligibilityOfflineDate,
            EligibilityResponseIdentifier: visit.eligibilityresponseidentifie,
            EligibilityOnline: this.state.elegibilityOnline,
            EligibilityOffline: this.state.elegibilityOffline,
            returnFullResponse: false,
            preAuthRef: visit.preAuthRef ? visit.preAuthRef : "",
            preAuthResponseIdentifier: visit.authorizationresponseidentifier,
            "encounter": {
              "ID": "123456",
              "status": "finished",
              "class": {
                "code": "AMB",
                "display": "Ambulatory"
              },
              "admitSource": "WKIN",
              "serviceEventType": "ICSE",
              "period": {
                "start": "2024-07-11T10:25:00+03:00",
               // "end": "2024-07-13T10:25:00+03:00"
              },
              "serviceProvider": {
                "ID": "10000300178702",
                "name": "Faraby"
              },
              "patientID": "2013456789"
            }
          }
        );
      }

      if (CheckAuthorizationResponse) {
        this.setState({ RequestSent: false, response: true });
        let { data } = CheckAuthorizationResponse;
        if (data) {
          setTimeout(() => {
            this.setState({ submitLoading: false });
          }, 500);
          let { success } = data;
          let {
            adjudicationOutcome,
            claimResponseIdentifier,
            outcome,
            items,
            Total,
            BundleID,
            requestIdentifier,
            error
          } = data;
          let updatedVisit
          if (success) {
            this.setState({ submissionError: "" })

            if (outcome == "complete") {
              updatedVisit = await this.handleAddClaimResponse(
                items,
                Total,
                claimResponseIdentifier,
                BundleID,
                adjudicationOutcome,
                outcome,
                requestIdentifier,
                visit["id"],
                []
              );
              this.getAllClaimInformation(updatedVisit,flag)
            } else if (outcome === "queued") {
              updatedVisit = await this.handleAddClaimResponse(
                [],
                [],
                claimResponseIdentifier,
                BundleID,
                "",
                outcome,
                requestIdentifier,
                visit["id"],
                []
              );
              this.getAllClaimInformation(updatedVisit,flag)

            }
          } else if (outcome === "error") {
            updatedVisit = await this.handleAddClaimResponse(
              [],
              [],
              claimResponseIdentifier,
              BundleID,
              "",
              outcome,
              requestIdentifier,
              visit["id"],
              error
            );
            this.getAllClaimInformation(updatedVisit,flag)


          }
          else {
            this.setState({ submissionError: error })
          }
        }
      }
    }
  };
  handleAddClaimResponse = async (
    items,
    Total,
    claimResponseIdentifier,
    BundleID,
    adjudicationOutcome,
    outcome,
    requestIdentifier,
    visitid,
    claimerror
  ) => {
    let currentdate = new Date();
    let createdat =
      currentdate.toISOString().slice(0, 10) +
      " " +
      currentdate.getHours() +
      ":" +
      currentdate.getMinutes() +
      ":" +
      currentdate.getSeconds();
    let data = {
      items: items,
      Total: Total,
      createdat: createdat,
      claimResponseIdentifier: claimResponseIdentifier,
      BundleID: BundleID,
      adjudicationOutcome: adjudicationOutcome,
      outcome: outcome,
      requestIdentifier: requestIdentifier,
      visitid: visitid,
      claimerror: claimerror
    };
    let Response = await axios.post(
      KayanURL + "api/KSA/RCM/ClaimSubmission/addNewClaim",
      {
        data,
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
      }
    );
    if (Response) {

      console.log("response",Response);
      let { data } = Response;
      if (data) {
        if (data.success) {
          return data.Claim
        } else {
          this.setState({ success: false });
        }
      }
    }
  };
  HandleInputSearchRequestTextChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let patientName, patientLastName = ""
    if (name === "name") {
      patientName = value.trim().split(" ");
      for (let i = 1; i < patientName.length; i++) {
        patientLastName += patientName[i] + " ";
      }
      this.setState({
        searchInfo: { ...this.state.searchInfo, firstname: patientName[0], lastname: patientLastName.trim() },
        name: value
      });
    } else {
      this.setState({
        searchInfo: { ...this.state.searchInfo, [name]: value },
        batchInfo: { ...this.state.searchInfo, [name]: value },
        [name]: value
      });
    }

  };
  handleSearchRequest = async () => {
    let { searchInfo } = this.state;
    if (Object.keys(searchInfo).length === 0 || searchInfo === undefined) {
      this.getAllVisits();
    }
    for (let key in searchInfo) {
      if (searchInfo.hasOwnProperty(key) && searchInfo[key] === "") {
        this.getAllVisits();
      } else {
        this.setState({ errMsg: "" })
        let result = await axios.put(
          KayanURL + "api/KSA/RCM/ClaimSubmission/getAllVisists",
          {
            searchInfo,
            apiToken: Cookies.get("RCM_KSA_Employee_Token"),
          }
        );
        if (result) {
          let { data } = result;
          if (data) {
            this.setState({ requestsFound: true });
            if (data.success) {
              this.setState({
                success: true, allvisits: data.visits,
              });
            } else {
              this.setState({
                success: false,
                error: data.error,
                allvisits: data.visits,
              });
            }
            this.setState({
              identifier: "",
              name: "",
              visitstartdate: null,
              visitenddate: null,
              tpa: "",
              payerid: "",
              searchInfo: {}
            });
          }

        }
      }
    }
  };
  HandleDateChange = (e) => {
    let date = moment(e.value.$d).format("YYYY-MM-DD");
    this.setState({
      searchInfo: { ...this.state.searchInfo, [e.name]: date },
      batchInfo: { ...this.state.batchInfo, [e.name]: date },
      [e.name]: date,
    });
  };
  handleCloseClaimInfo = () => {
    this.setState({
      viewClaimSubmissionInfoModal: false,
      editClaim: false,
      checkStatusFlag: false,
      // addProcedure: false,
      addVital: false,
      // AddDiagnosis: false,
      vitalSignSelectArray: [],
      allDiagnosisSelect: [],
      cancelErrors: [],
      statusErrors: [],
      selectedVisit: null,
      checkInvoice: false,
      submissionError: "",
      invoiceMsg: "",
      procedureSeq: [],
      procedures: [],
      allproceduresFlag: false,
      InvoiceNumberError: "",
      cancelError:""
    });
    this.getAllVisits();
  };
  handleSubmitBatch = async (e) => {
    e.preventDefault();
    let { batchInfo, claims } = this.state
    if (!batchInfo.payerid || !batchInfo.visitstartdate || !batchInfo.visitenddate)
      this.setState({ batchError: "Insurance, Start and End Date are required !" })

    else {
      this.setState({
        RequestSent: true, checkResponse: false, batchError: "", batchLoading: true, batchInfo: {}, identifier: "",
        name: "",
        visitstartdate: null,
        visitenddate: null,
        tpa: "",
        payerid: "",
        InvoiceNumberError: ""
      });
      if (claims && claims.length > 0) {
      let allvisits = await this.getAllVisits();
        // console.log(allvisits, 'visits from batch')
        let InvoiceClaims = [];

        // console.log(InvoiceClaims, 'ar1')
        for (let i = 0; i < claims.length; i++) {
          // let { procedures } = claims[i];
          let visit = allvisits.filter(item => item.id == claims[i].visitNumber);
          console.log(visit[0].allprocedures, 'visit')
          if (visit && visit.length > 0) {
            claims[i].procedures.forEach(item2 => {
              let item1 =  visit[0].allprocedures.find(item => item.code === item2.code);
              if (item1) {
                  Object.keys(item1).forEach(key => {
                      item2[key] = item1[key];
                  });
              }
          });
            // claims[i].procedures = visit[0].allprocedures
            // console.log(claims[i],'new claim',i)
            // console.log(claims[i].procedures,'new ppppppppppppp')
          }

          let hasMissingInvoice = false;
          if (claims[i].procedures && claims[i].procedures.length > 0) {
            for (let j = 0; j < claims[i].procedures.length; j++) {
              // console.log(claims[i].procedures[j], `iiiiiiiiiiiiiiiiiiiiiiiiiii ${i}`)
              if (!claims[i].procedures[j].invoice) {
                hasMissingInvoice = true; // Set flag if procedure lacks an invoice
                break;
              }
            }
          }
          // Only push claim visit number if all procedures have invoices
          if (hasMissingInvoice === true) {
            InvoiceClaims.push(`Claim #${claims[i].visitNumber}`);
          }
        }


        console.log(InvoiceClaims, 'ar2')
        if (InvoiceClaims.length > 0) {
          const errorMessage = `${InvoiceClaims.join(', ')} Must have Invoice Number!`;
          console.log(errorMessage, 'errorMsg')
          this.setState({ InvoiceNumberError: errorMessage, batchLoading: false });

        }
        else {
          let BatchSubmissionResponse = await axios.post(
            "http://141.147.130.248:4000/api/KSA/RCM/request",
            {
              apiToken: "token",
              requestType: "4",
              payerID: batchInfo.payerid ? batchInfo.payerid : "",
              payerName: allInsuraceCompanies[batchInfo.payerid],
              TPA: batchInfo.tpa ? batchInfo.tpa : "",
              providerID: localStorage.getItem("nphies-id"),
              providerName: localStorage.getItem("nphies-provider-name"),
              batchPeriodFrom: batchInfo.visitstartdate,
              batchPeriodTo: batchInfo.visitenddate,
              claims: claims,
              testing: localStorage.getItem("nphies-id") === "10000300178702" ? true : false,

            }
          );
          if (BatchSubmissionResponse) {
            this.setState({
              RequestSent: false,
              checkResponse: true,
            });

            let { data } = BatchSubmissionResponse;
            if (data) {
              let { success, responses } = data;
              setTimeout(() => {
                this.setState({ batchLoading: false });
              }, 1000);
              if (success) {
                this.setState({
                  success: true,
                  checkboxFlag: false,
                });
                if (responses && responses.length > 0) {
                  this.setState({ checkAll: false, claimSeq: [] })
                  for (let i = 0; i < responses.length; i++) {
                    let { ResponseBuisnessIdentifier, outcome, requestIdentifier, errors, BundleID, visitNumber, Total, items, adjudicationOutcome } = responses[i];

                    if (outcome === "error") {
                      await this.handleAddClaimResponse(
                        [],
                        [],
                        ResponseBuisnessIdentifier,
                        BundleID,
                        "",
                        outcome,
                        requestIdentifier,
                        visitNumber,
                        errors
                      )
                    } else if (outcome === "queued") {
                      await this.handleAddClaimResponse(
                        [],
                        [],
                        ResponseBuisnessIdentifier,
                        BundleID,
                        "",
                        outcome,
                        requestIdentifier,
                        visitNumber,
                        []
                      )
                    } else if (outcome === "complete") {
                      await this.handleAddClaimResponse(
                        items,
                        Total,
                        ResponseBuisnessIdentifier,
                        BundleID,
                        adjudicationOutcome,
                        outcome,
                        requestIdentifier,
                        visitNumber,
                        []
                      )
                    }
                  }
                  await this.getAllVisits();
                  this.setState({ claims: [] })
                }
                this.setState({batchSubmissionFlag:false})
              }
            }
          }
        }

      }
    }

  };

  handleCheckBoxChange = async (e, visitId, index) => {
    let { allvisits, claims, claimSeq, procedures, selectedVisit, procedureSeq } = this.state;
    let selectedClaim
    let getApprovalInfo
    let procedureIndex
    if (e.target.name == "allProcedures") {
      let { allprocedures } = selectedVisit

      if (e.target.checked) {

        procedures.splice(0, procedures.length)
        procedureSeq.splice(0, procedureSeq.length)
        for (let i = 0; i < allprocedures.length; i++) {
          procedureSeq.push(i + 1)
          procedures.push(allprocedures[i])
        }
        this.setState({ procedures, procedureSeq, allproceduresFlag: true, })
      }
      else {

        procedures = []
        this.setState({
          procedures,
          procedureSeq: [],
          allproceduresFlag: false,

        })
      }
    }
    else if (e.target.name == "selectProcedure") {

      if (e.target.checked) {
        let { allprocedures } = selectedVisit
        let element = allprocedures[index]
        procedureIndex = selectedVisit["allprocedures"].indexOf(element)
        procedures.push(element)
        procedureSeq.push(procedureIndex + 1)
        this.setState({ procedures, procedureSeq })
      } else {
        procedureIndex = procedureSeq.indexOf(index + 1)
        procedures.splice(procedureIndex, 1);
        procedureSeq.splice(procedureIndex, 1);
        if (procedures.length == 0)
          this.setState({ allproceduresFlag: false })
        this.setState({ procedures, procedureSeq })
      }
    }

    else if (e.target.name == "selectAll") {
      console.log("batch")
      if (e.target.checked) {
        claims.splice(0, claims.length);
        claimSeq.splice(0, claimSeq.length);
        for (let i = 0; i < allvisits.length; i++) {
          let newProcedures=[]
          getApprovalInfo = await axios.put(
            KayanURL + "api/KSA/RCM/patient/getAllAuthInfoByVisitID",
            {
              apiToken: Cookies.get("RCM_KSA_Employee_Token"),
              visitId: allvisits[i].id,
            }
          );
          if (getApprovalInfo) {
            let { data } = getApprovalInfo;
            if (data.success) {
              let { AllApproval } = data;

              if (AllApproval && AllApproval.length > 0) {
                if (AllApproval.length == 1) {
                  let {
                    preauthref, authorizationresponseoutcome, authorizationresponseidentifier,
                  } = AllApproval[0];


                  allvisits[i]["authorizationresponseidentifier"] = authorizationresponseidentifier
                  if (authorizationresponseoutcome === "complete") {
                    allvisits[i]["preAuthRef"] = preauthref;

                  }


                } else {
                  AllApproval.sort((a, b) => a.id - b.id);
                  AllApproval = AllApproval[AllApproval.length - 1];
                  let {
                    authorizationresponseidentifier,
                    preauthref,
                    authorizationresponseoutcome
                  } = AllApproval;
                  allvisits[i]["authorizationresponseidentifier"] = authorizationresponseidentifier
                  if (authorizationresponseoutcome === "complete") {
                    allvisits[i]["preAuthRef"] = preauthref;

                  }
                }

              }


            }
          }
          let coverageInfo;
          let doctor = [];
          let doctorLastName = "";
          let doctorName;
          if (allvisits[i].doctorid) {
            doctor = await this.getDoctorByID(allvisits[i].doctorid);
            doctorName = doctor[0]["name"].split(" ");
            for (let i = 1; i < doctorName.length; i++) {
              doctorLastName += doctorName[i] + " ";
            }
          }
          if (
            allvisits[i].selectedinsurance &&
            allvisits[i].selectedinsurance.length > 0
          ) {

            let { coverage } = allvisits[i].selectedinsurance[0];
            let { paymentDetails } = coverage[0];
            let cost = [];
            for (let i = 0; i < paymentDetails.length; i++) {
              let keys = Object.keys(paymentDetails[i]);
              if (keys[0] === "spvisit") {
                let valueOfKey = paymentDetails[i][keys];
                cost.push({ [keys]: valueOfKey.toString() });
              } else {
                let valueOfKey = paymentDetails[i][keys].split(" ")[0];
                cost.push({ [keys]: valueOfKey });
              }
            }
            coverageInfo = {
              class: coverage[0].class,
              "coverage-type": coverage[0]["coverage-type"],
              memberid: coverage[0].memberid,
              network: coverage[0].network,
              period: coverage[0].period,
              "subscriber-relationship": coverage[0]["subscriber-relationship"],
              paymentDetails: cost,
            };
          }
          let flag=true
          await this.getAllClaimInformation(allvisits[i],flag)

          claims.push(
            {
              visitid: allvisits[i].id,
              visitNumber: allvisits[i].id,
              payerID: allvisits[i].payerid,
              payerName: allvisits[i].payername,
              providerID: localStorage.getItem("nphies-id"),
              providerName: localStorage.getItem("nphies-provider-name"),
              patient: {
                ID: allvisits[i].identifier,
                firstName: allvisits[i]["firstname"],
                lastName: allvisits[i]["lastname"],
                phone: allvisits[i]["phone"],
                gender: allvisits[i]["gender"],
                birthDate: allvisits[i]["birthdate"],
                nationality: allvisits[i]["nationality"],
                identifierType: allvisits[i]["identifiertype"],
              },
              doctor: {
                firstName: doctorName[0],
                lastName: doctorLastName,
                practiceCode: doctor[0].doctor_practice_code,
                license: doctor[0].doctor_license,
              },
              coverage: coverageInfo,
              codingSystem: "internal",
              supportingInformation: allvisits[i].supportinginformation,
              claimType: allvisits[i].claimtype,
              claimSubType: "op",
              diagnosis: allvisits[i].diagnosis,
              procedures: allvisits[i].allprocedures,
              //
              preAuthRef: allvisits[i].preAuthRef,
              preAuthResponseIdentifier:
                allvisits[i].authorizationresponseidentifier
                  ? allvisits[i].authorizationresponseidentifier
                  : "",
              //
              preAuthOfflineDate: this.state.preAuthOfflineDate,
              eligibilityOfflineDate: this.state.eligibilityOfflineDate,
              EligibilityResponseIdentifier: allvisits[i].eligibilityresponseidentifier,
            });
          if (allvisits[i].authorizationstatus === "4" || allvisits[i].authorizationstatus === "2" || allvisits[i].authorizationstatus === "1" || allvisits[i].authorizationstatus === "cancelled") {
            delete claims[i].preAuthRef
            delete claims[i].preAuthResponseIdentifier
          }

          claimSeq.push(i + 1);
        }
        if (claims && claims.length > 0) {
          this.setState({
            claims,
            batchSubmissionFlag: true,
            claimSeq,
            checkAll: true
          });
        }
      } else {
        this.setState({
          claims: [],
          claimSeq: [],
          batchSubmissionFlag: false,
          checkAll: false
        });
      }
    } else {
      if (e.target.checked) {
            //  console.log(this.state.procedureSeq,'hoooooon')
        let coverageInfo,
          selectedClaim = allvisits.find(item => allvisits.indexOf(item) == index);
        if (selectedClaim) {
          let newProcedures=[];
          getApprovalInfo = await axios.put(
            KayanURL + "api/KSA/RCM/patient/getAllAuthInfoByVisitID",
            {
              apiToken: Cookies.get("RCM_KSA_Employee_Token"),
              visitId: selectedClaim.id,
            }
          );
          if (getApprovalInfo) {
            let { data } = getApprovalInfo;
            if (data.success) {
              let { AllApproval } = data;

              if (AllApproval && AllApproval.length > 0) {
                if (AllApproval.length == 1) {
                  let {
                    preauthref, authorizationresponseoutcome, authorizationresponseidentifier,
                  } = AllApproval[0];
                  selectedClaim["authorizationresponseidentifier"] = authorizationresponseidentifier
                  if (authorizationresponseoutcome === "complete") {
                    selectedClaim["preAuthRef"] = preauthref;

                  }


                } else {
                  AllApproval.sort((a, b) => a.id - b.id);
                  AllApproval = AllApproval[AllApproval.length - 1];
                  let {
                    authorizationresponseidentifier,
                    preauthref,
                    authorizationresponseoutcome
                  } = AllApproval;
                  selectedClaim["authorizationresponseidentifier"] = authorizationresponseidentifier
                  if (authorizationresponseoutcome === "complete") {
                    selectedClaim["preAuthRef"] = preauthref;

                  }
                }

              }


            }
          }
          let doctor = [];
          let doctorLastName = "";
          let doctorName;
          if (selectedClaim.doctorid) {
            doctor = await this.getDoctorByID(selectedClaim.doctorid);
            doctorName = doctor[0]["name"].split(" ");
            for (let i = 1; i < doctorName.length; i++) {
              doctorLastName += doctorName[i] + " ";
            }
          }
          if (
            selectedClaim.selectedinsurance &&
            selectedClaim.selectedinsurance.length > 0
          ) {
            let { coverage } = selectedClaim.selectedinsurance[0];
            let { paymentDetails } = coverage[0];
            let cost = [];
            for (let i = 0; i < paymentDetails.length; i++) {
              let keys = Object.keys(paymentDetails[i]);
              if (keys[0] === "spvisit") {
                let valueOfKey = paymentDetails[i][keys];
                cost.push({ [keys]: valueOfKey.toString() });
              } else {
                let valueOfKey = paymentDetails[i][keys].split(" ")[0];
                cost.push({ [keys]: valueOfKey });
              }
            }
            coverageInfo = {
              class: coverage[0].class,
              "coverage-type": coverage[0]["coverage-type"],
              memberid: coverage[0].memberid,
              network: coverage[0].network,
              period: coverage[0].period,
              "subscriber-relationship": coverage[0]["subscriber-relationship"],
              paymentDetails: cost,
            };
          }let flag = true;         
          await this.getAllClaimInformation(selectedClaim,flag)
           console.log(selectedClaim,'hereeeeeeopopppppp')
         
          // console.log(newProcedures,'newprooo')
          claims.push(
            {
              visitid: visitId,
              visitNumber: visitId,
              payerID: selectedClaim.payerid,
              payerName: selectedClaim.payername,
              providerID: localStorage.getItem("nphies-id"),
              providerName: localStorage.getItem("nphies-provider-name"),
              patient: {
                ID: selectedClaim.identifier,
                firstName: selectedClaim["firstname"],
                lastName: selectedClaim["lastname"],
                phone: selectedClaim["phone"],
                gender: selectedClaim["gender"],
                birthDate: selectedClaim["birthdate"],
                nationality: selectedClaim["nationality"],
                identifierType: selectedClaim["identifiertype"],
              },
              doctor: {
                firstName: doctorName[0],
                lastName: doctorLastName,
                practiceCode: doctor[0].doctor_practice_code,
                license: doctor[0].doctor_license,
              },
              coverage: coverageInfo,
              supportingInformation: selectedClaim.supportinginformation,
              claimType: selectedClaim.claimtype,
              claimSubType: "op",
              codingSystem: "internal",
              diagnosis: selectedClaim.diagnosis,
              procedures: selectedClaim.allprocedures,
              //
              preAuthRef: selectedClaim.preAuthRef,
              preAuthResponseIdentifier:
                selectedClaim.authorizationresponseidentifier
                  ? selectedClaim.authorizationresponseidentifier
                  : "",
              //
              preAuthOfflineDate: this.state.preAuthOfflineDate,
              eligibilityOfflineDate: this.state.eligibilityOfflineDate,
              EligibilityResponseIdentifier: selectedClaim.eligibilityresponseidentifier,
            }
          );
          if (selectedClaim.authorizationstatus === "4" || selectedClaim.authorizationstatus === "2" || selectedClaim.authorizationstatus === "1" || selectedClaim.authorizationstatus === "cancelled") {
            claims.forEach(element => {
              console.log(element, "element")
              if (element.visitid == selectedClaim.id) {
                delete element.preAuthRef
                delete element.preAuthResponseIdentifier
              }

            });
          }
          claimSeq.push(
            allvisits.indexOf(selectedClaim) + 1
          );
        }

        this.setState({ claims, claimSeq, batchSubmissionFlag: true });

      } else {

        let i = claimSeq.indexOf(index + 1);
        claims.splice(i, 1);
        claimSeq.splice(i, 1);


        if (claims.length == 0)
          this.setState({ batchSubmissionFlag: false, checkAll: false });
        this.setState({ claimSeq })
      }
    }
  };
 
  handleDeleteProcedure = (index) => {
    let { selectedVisit } = this.state;
    selectedVisit["allprocedures"].splice(index, 1);
    if (selectedVisit["allprocedures"].length == 0)
      this.setState({ addProcedure: true });
    this.setState({ selectedVisit });
  };
  HandleProcedureChange = (e, index) => {
    let { selectedVisit } = this.state;
    selectedVisit["allprocedures"][index]["invoice"] = e.target.value
    this.setState({ selectedVisit })
  };

  HandleVitalSignChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState({ vitalSelect: value });
    if (value) {
      name = value;
      this.setState({ vitalSignSelected: true, selectedName: value });
      if (value === "chief-complaint") {
        this.setState({
          chiefComplainSelected: true,
        });
      } else {
        this.setState({
          chiefComplainSelected: false,
        });
      }
      if (value == "attachment") {
        this.setState({ attachmentSelected: true });
      } else {
        this.setState({ attachmentSelected: false });
      }
    } else {
      this.setState({ vitalSignSelected: false });
    }
  };
  HandleSupportingInfoChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let { selectedName } = this.state;
    if (name === "days-supply") {
      selectedName = name;
      this.setState({ selectedName });
    }
    if (selectedName === "chief-complaint") {
      this.setState({
        vitalSignJson: { display: selectedName, valueInfo: { text: value } },
        vitalSignSelectJson: {
          display: selectedName + " " + value,
          valueInfo: value,
        },
        vitalValue: value,
      });
    } else {
      this.setState({
        vitalSignJson: { display: selectedName, valueInfo: value },
        vitalSignSelectJson: {
          display: selectedName + " " + value,
          valueInfo: value,
        },
        vitalValue: value,
      });
    }
  };

  handleConfirm = async (e) => {
    e.preventDefault();
    if (this.state.attachmentSelected && !this.state.selectedFile) {
      this.setState({
        fileMsg: "please select a file !",
      });
    } else {
      let {
        selectedVisit,
        supportingInfoarray,
        vitalSignJson,
        vitalSignSelectJson,
        vitalSignSelectArray,
      } = this.state;
      this.setState({ vitalSelect: "", vitalValue: "" });
      if (this.state.selectedName === "attachment") {
        const lastModifiedDateStr = vitalSignJson.valueInfo.lastModifiedDate;

        const lastModifiedDate = new Date(lastModifiedDateStr);
        const year = lastModifiedDate.getFullYear();
        const month = String(lastModifiedDate.getMonth() + 1).padStart(2, "0");
        const day = String(lastModifiedDate.getDate()).padStart(2, "0");
        const formattedDate = `${year}-${month}-${day}`;
        selectedVisit["supportinginformation"].push({
          [vitalSignJson.display]: {
            contentType: vitalSignJson.valueInfo.type,
            title: vitalSignJson.valueInfo.name,
            data: vitalSignJson.data,
            // creation: (vitalSignJson.valueInfo.lastModifiedDate.toString()).split('(')[0].trim()
            creation: formattedDate,
          },
        });
      } else {
        if (
          selectedVisit.supportinginformation &&
          selectedVisit.supportinginformation.length > 0
        ) {
          selectedVisit["supportinginformation"].push({
            [vitalSignJson.display]: vitalSignJson.valueInfo,
          });
        } else {
          selectedVisit["supportinginformation"].push({
            [vitalSignJson.display]: vitalSignJson.valueInfo,
          });
        }
      }

      // vitalSignsArray.push(vitalSignJson);

      if (this.state.selectedName !== "days-supply")
        vitalSignSelectArray.push(vitalSignSelectJson);

      this.setState((prevState) => ({
        selectedFile: "",
        addVital: false,
        vitalSignSelectArray,
        key: prevState.key + 1
      }));
    }
  };
  handleDeleteVital = (index) => {
    let { vitalSignSelectArray, selectedVisit } = this.state;
    vitalSignSelectArray.splice(index, 1);
    if (selectedVisit["allprocedures"] &&
      selectedVisit["allprocedures"].length > 0) {
      let procedures = selectedVisit["allprocedures"];
      for (let i = 0; i < procedures.length; i++) {
        let infoSeq
        if (procedures[i].informationSequence && procedures[i].informationSequence.length > 0) {
          infoSeq = procedures[i].informationSequence;
          let target = index + 1
          if (infoSeq.includes(index + 1)) {
            infoSeq.splice(infoSeq.indexOf(target), 1)
            for (let i = 0; i < infoSeq.length; i++) {
              if (infoSeq[i] > target) {
                infoSeq[i] = infoSeq[i] - 1
              }
              else {
                infoSeq[i] = infoSeq[i]
              }
            }

          } else {
            console.log('here')
            for (let i = 0; i < infoSeq.length; i++) {
              if (infoSeq[i] > target) {
                infoSeq[i] = infoSeq[i] - 1
              } else {
                infoSeq[i] = infoSeq[i]
              }
            }
          }
          procedures[i].informationSequence = infoSeq

        }

      }
      selectedVisit["allprocedures"] = procedures

    }
    selectedVisit.supportinginformation.splice(index, 1);
    if (selectedVisit.supportinginformation.length == 0)
      this.setState({ addVital: true });
    this.setState({ vitalSignSelectArray, selectedVisit });
  };
  SelectCategoryForProcedure = (selectedList, index) => {
    let { vitalSignSelectArray, selectedVisit } = this.state;
    let Values = [];
    selectedList.forEach((item) => {
      Values.push(vitalSignSelectArray.indexOf(item) + 1);
    });
    selectedVisit["allprocedures"][index].informationSequence = Values
    this.setState({
      selectedVisit

    });
    // }


  };
  RemoveCategoryForProcedure = (selectedList, removedItem, index) => {
    let { vitalSignSelectArray, selectedVisit } = this.state;
    let Values = [];
    selectedList.forEach((item) => {
      if (
        vitalSignSelectArray.indexOf(item) + 1 !=
        vitalSignSelectArray.indexOf(removedItem) + 1
      ) {
        Values.push(vitalSignSelectArray.indexOf(item) + 1);
      }
    });
    selectedVisit["allprocedures"][index].informationSequence = Values
    this.setState({
      selectedVisit

    });
  };
  onFileChange = async (e) => {
    this.setState({ selectedFile: e.target.files[0] });
    const allowedExtensions = ["pdf"];
    const fileExtension = e.target.files[0].name.split(".").pop().toLowerCase();

    if (!allowedExtensions.includes(fileExtension)) {
      this.setState({
        fileMsg: "Please select a PDF file.",
      });
    } else {

      this.setState({ fileMsg: "" });
      let res = await this.readContent(e.target.files[0]);
      this.setState({
        vitalSignJson: {
          display: "attachment",
          valueInfo: e.target.files[0],
          data: res,
        },
        vitalSignSelectJson: {
          display: "attachment" + " " + e.target.files[0].name,
          valueInfo: e.target.files[0].name,
        },
        vitalValue: e.target.files[0].name,
        selectedName: "attachment",
      });
    }

  };
  readContent = async (files) => {
    let fileReader = new FileReader();
    let fileToLoad = files;
    let file = "";
    return new Promise((resolve, reject) => {
      fileReader.onload = async (fileLoadedEvent) => {
        file = fileLoadedEvent.target.result;
        resolve(file.split(",")[1]);
      };
      fileReader.readAsDataURL(fileToLoad);
    });
  };
  handleCansulation = async (e, element) => {
    e.preventDefault();
    // console.log(element,'cancelElem')
    let { nphiesID } = this.state;
    this.setState({
      cancelLoading: true,
      cancelErrors: [],
      statusErrors: [],
      cancelError:""
    });
    let flag =false
    let CancelResponse = await axios.post(
      // KayanURL
      "http://141.147.130.248:4000/" + "api/KSA/RCM/request",
      {
        apiToken: "token",
        requestType: "6",
        payerID: element.payerid,
        TPA: element.tpa ? element.tpa : "",
        providerID: nphiesID,
        providerName: localStorage.getItem("nphies-provider-name"),
        payerName: element.payername,
        requestIdentifier: element.claimrequestidentifier,
        code: "cancel",
        testing: nphiesID === "10000300178702" ? true : false,
      }
    );

    // console.log("cancel Response", CancelResponse);

    if (CancelResponse) {
      setTimeout(() => {
        this.setState({ cancelLoading: false });
      }, 500);
      let { data } = CancelResponse;
      if (data) {
        let { success, error, response } = data;
        if (success) {
          let cancelStatus
          console.log(success);
          let res =/*  JSON.parse(response) */response;

          let { entry } = res;
          if (entry && entry.length > 0) {
            let { reference } = entry[0]["resource"]["focus"][0];
            let taskResource = entry.filter((element) => {
              return element["fullUrl"] == reference;
            });

            if (taskResource && taskResource.length > 0) {
              console.log(taskResource, 'tasksss')
              let errors = []
              let { output, status, code } = taskResource[0]["resource"];

              if (output && output.length > 0) {
                for (let i = 0; i < output.length; i++) {
                  if (status == "failed") {
                    let { code, display, extension } =
                      output[i]["valueCodeableConcept"]["coding"][0];

                   // let { valueString } = extension[0];

                    let valueString 
                      if(extension && extension.length>0){
                         valueString = extension[0]["valueString"];
                      }
                    errors.push({
                      codeError: code,
                      errorMsg: display,
                      details: valueString,
                    });
                    console.log(errors, 'errors')
                    this.setState({ cancelErrors: errors })
                  }
                }
              } else {
                console.log(code.coding[0].code)
                if (code.coding && code.coding.length > 0) {
                  cancelStatus = code.coding[0].code;
                }
              }
            }
          }
          if (cancelStatus === "cancel") {
            let response = await axios.put(
              KayanURL + "api/KSA/RCM/ClaimSubmission/updateVisitStatus",
              {
                apiToken: Cookies.get("RCM_KSA_Employee_Token"),
                visitid: element.id,
                claimResponseoutcome: "cancellation",
              }
            );

            if (response) {
              let { data } = response;
              if (data) {
                console.log(data);
                let { success, error } = data;
                if (success) {
                  this.getAllClaimInformation(data.Claim,flag)
                }
              }
            }
          }

        }else{
          this.setState({cancelError:error})
        }
      }
    }
  };
  handleCheck = async (e, element) => {
    // console.log(element, "check status");
    e.preventDefault();
    let { nphiesID } = this.state;
    this.setState({ statusLoading: true, statusErrors: [], cancelErrors: [],cancelError:"" });
    let errors = [];
    let checkStatusRequest = await axios.post(
      "http://141.147.130.248:4000/api/KSA/RCM/request",
      // KayanURL + "api/KSA/RCM/request",
      {
        apiToken: "token",
        requestType: 8,
        payerID: element.payerid,
        TPA: element.tpa ? element.tpa : "",
        providerID: nphiesID,
        providerType:1,
        providerName: localStorage.getItem("nphies-provider-name"),
        payerName: element.payername,
        requestIdentifier: element.claimrequestidentifier,
        testing: nphiesID === "10000300178702" ? true : false,
      }
    );

    if (checkStatusRequest) {
      setTimeout(() => {
        this.setState({ statusLoading: false });
      }, 1000);

      let { data } = checkStatusRequest;

      if (data) {
        console.log(data);
        setTimeout(() => {
          this.setState({ checkStatusFlag: false })
        }, 2000)
        let { success, error, response } = data;
        if (success) {
          this.setState({ checkStatusFlag: true });

          let res =response/*  JSON.parse(response) */;

          let { entry } = res;
          if (entry && entry.length > 0) {
            let { reference } = entry[0]["resource"]["focus"][0];
            let taskResource = entry.filter((element) => {
              return element["fullUrl"] == reference;
            });

            if (taskResource && taskResource.length > 0) {
              let { output, status } = taskResource[0]["resource"];

              if (output && output.length > 0) {
                for (let i = 0; i < output.length; i++) {
                  console.log(output[i], 'output')
                  if (status == "failed") {
                    let { code, display } =
                      output[i]["valueCodeableConcept"]["coding"][0];
                    let { valueString } =
                      output[i]["valueCodeableConcept"]["coding"][0][
                      "extension"
                      ][0];
                    errors.push({
                      codeError: code,
                      errorMsg: display,
                      details: valueString,
                    });
                    this.setState({ valueCode: "", statusErrors: errors })
                  }
                  else {
                    let { valueCode } = output[i]
                    this.setState({ valueCode })
                  }
                }
              }
            }
          }
          this.setState({ res, success, errors });

        } else {
          this.setState({ error });
          console.log(error);
        }
      }
    }
  };

  //communication
  handleCloseCommunicationModal = () => {
    this.setState({
      communicationModalOpen: false,
      communicationError: [],
      acknowledgmentStatus: "",
      communicationCategory: "",
      content: "",
      basedOnValue: "",
      communicationData: "",
      communicationFileName: ""

    });
  };
  handleCloseErrorModal = () => {
    this.setState({
      communicationTransactionErrors: [],
      showError: false
    })
  }
  handleCloseCommunicationHistoryModal = () => {
    this.setState({ communicationHistoryModalOpen: false })
  }
  HandleCommunicationInputChange = async (e) => {
    let name = e.target.name;
    let value = e.target.value;
    if (name === "communicationAttachment") {
      let res = await this.readContent(e.target.files[0]);
      this.setState({
        communicationData: res,
        communicationFileName: e.target.files[0].name.split(".")[0]
      });

    } else {
      this.setState({ [name]: value })
    }
  };
  handleSend = async (e) => {
    e.preventDefault();
    let { selectedVisit, nphiesID } = this.state;
    this.setState({ sendLoading: true, communicationError: [], acknowledgmentStatus: "" });
    let errors = [];
    let basedOn
    let sendRequest = await axios.post(
      "http://141.147.130.248:4000/api/KSA/RCM/request",
      // KayanURL + "api/KSA/RCM/request",
      {
        apiToken: "token",
        requestType: 9,
        payerID: selectedVisit.payerid,
        TPA: selectedVisit.tpa ? selectedVisit.tpa : "",
        providerID: nphiesID,
        providerName: localStorage.getItem("nphies-provider-name"),
        payerName: selectedVisit.payername,
        claimRequestIdentifier: selectedVisit.claimrequestidentifier,
        content: this.state.content,
        communicationCategory: this.state.communicationCategory,
        patient: {
          ID: selectedVisit.identifier,
          firstName: selectedVisit["firstname"],
          lastName: selectedVisit["lastname"],
          phone: selectedVisit["phone"],
          gender: selectedVisit["gender"],
          birthDate: selectedVisit["birthdate"],
          identifierType: selectedVisit["identifiertype"],
        },
        attachmentEncodedData: this.state.communicationData,
        title: this.state.communicationFileName,
        testing: true
      }
    );

    if (sendRequest) {
      let { data } = sendRequest;
      if (data) {
        console.log(data, 'from comunication');

        let { success, error, BundleID, acknowledgmentStatus } = data;
        if (BundleID) {
          this.setState({ BundleID })
        }
        if (this.state.basedOnValue) {
          basedOn = this.state.basedOnValue;
        } else {
          basedOn = ""
        }
        if (success) {
          setTimeout(() => {
            this.setState({ sendLoading: false });
          }, 2000);
          if (acknowledgmentStatus === 'fatal-error' && error && error.length > 0) {
            this.setState({ communicationError: error, acknowledgmentStatus })
            this.handleAddCommunicationTransactionInfo(
              this.state.communicationData,
              this.state.content,
              selectedVisit.claimrequestidentifier,
              this.state.communicationCategory,
              error,
              basedOn
            );
          } else {
            this.setState({ acknowledgmentStatus })
            this.handleAddCommunicationTransactionInfo(
              this.state.communicationData,
              this.state.content,
              selectedVisit.claimrequestidentifier,
              this.state.communicationCategory,
              [],
              basedOn
            );
          }

        } else {
          this.setState({ error });
          console.log(error);
        }
      }
    }
    if (this.fileInputRef.current) {
      this.fileInputRef.current.value = null;
    }
    this.setState({
      content: "",
      communicationCategory: ""
    })

  };
  handleAddCommunicationTransactionInfo = async (
    communicationData,
    content,
    claimrequestidentifier,
    communicationCategory,
    error,
    basedOn
  ) => {
    let Response = await axios.post(
      KayanURL + "api/KSA/RCM/patient/addCommunicationTransaction",
      {
        data: {
          attachment: communicationData,
          content: content,
          communicationType: basedOn ? "solicited" : "unsolicited",
          requestType: "Claim",
          basedOn: basedOn ? basedOn : "",
          communicationError: error,
          requestIdentifier: claimrequestidentifier,
          communicationCategory: communicationCategory,
          acknowledgmentStatus: error && error.length > 0 ? "not sent" : "sent"
        },
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
      }
    );
    if (Response) {
      let { data } = Response;
      console.log(data);
      if (data) {
        if (data.success) {
          this.getAllCommunicationTransactionInfoByReqIdentefier();
          if (basedOn && error.length === 0) {
            this.handleUpdateCommunicationRequeststatus()
          }
        } else {
          this.setState({ success: false });
        }
      }
    }
  };
  handleUpdateCommunicationRequeststatus = async () => {
    let Response = await axios.put(
      KayanURL + "api/KSA/RCM/patient/updateCommunicationRequest",
      {
        communicationAbout: this.state.communicationAboutValue,
        acknowledgmentStatus: "replyed",
        ID: this.state.idValue,
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
      }
    );
    if (Response) {
      let { data } = Response;
      console.log(data);
      if (data) {
        if (data.success) {
          this.getAllCommunicationRequestInfoByReqIdentefier();
        } else {
          console.log(
            "error in update or add the authorization response of a visit:",
            data.error
          );
          this.setState({ success: false /* , error: data.error */ });
        }
      }
    }
  };
  getAllCommunicationTransactionInfoByReqIdentefier = async () => {
    this.setState({ communicationTransactionLoading: true })
    let response = await axios.put(
      KayanURL + "api/KSA/RCM/patient/getCommunicationTransaction",
      {
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
        requestIdentifier: this.state.selectedVisit.claimrequestidentifier,
        requestType: "Claim",
      }
    );
    if (response) {
      let { data } = response;
      if (data) {
        this.setState({ communicationTransactionLoading: false })
        if (data.success) {
          this.setState({
            success: true,
            communicationTransactionSuccess: true,
            transactionsData: data.transactionsData
          });
        } else {
          this.setState({
            success: false,
            communicationTransactionSuccess: false,
            error: data.error,
          });
        }

      }
    }

  };
  getAllCommunicationRequestInfoByReqIdentefier = async () => {
    // e.preventDefault();
    this.setState({ communicationRequestLoading: true })
    console.log(this.state.selectedVisit, 'from get comm')
    let response = await axios.put(
      KayanURL + "api/KSA/RCM/patient/getCommunicationRequest",
      {
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
        communicationAbout: this.state.selectedVisit.claimrequestidentifier
      }
    );
    if (response) {
      let { data } = response;
      if (data) {
        this.setState({ communicationRequestLoading: false })
        if (data.success) {
          this.setState({
            success: true,
            communicationReqSuccess: true,
            requestData: data.requestData
          });
        } else {
          this.setState({
            success: false,
            communicationReqSuccess: false,
            error: data.error,
          });
        }

      }
    }

  };
  handlePollingCommunicationRequest = async () => {
    this.setState({ pollCommLoading: true });
    let result = await axios.post(
      "http://141.147.130.248:4000/api/KSA/RCM/request",
      {
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),

        requestType: 5,
        providerName: localStorage.getItem("nphies-provider-name"),
        providerID: localStorage.getItem("nphies-id"),
        include: "communication-request",
        returnFullResponse: false,
        testing: true,
      }
    );
    // result = {
    //   data: {
    //     "success": true,
    //     "BundleID": "b22b775e-0e24-49f5-9c28-3c4ac62cf96f",
    //     "communicationRequests": [
    //       {
    //         "communicationRequestIdentifier": "http://sni.com.sa/communicationrequest/CommReq_306278",
    //         "communicationCategory": "instruction",
    //         "communicationContent": [
    //           {
    //             "contentString": "Please provide an updated lab report including HbAIC, LFT and Lipid profiles."
    //           }
    //         ],
    //         "communicationAbout": "http://141.147.130.248/Claim/req_32018"
    //       },
    //       {
    //         "communicationRequestIdentifier": "http://sni.com.sa/communicationrequest/CommReq_306278",
    //         "communicationCategory": "instruction",
    //         "communicationContent": [
    //           {
    //             "contentString": "Please provide an updated lab report including HbAIC, LFT and Lipid profiles."
    //           }
    //         ],
    //         "communicationAbout": "http://141.147.130.248/Claim/req_43480"
    //       }
    //     ]
    //   }
    // }
    if (result) {
      setTimeout(() => {
        this.setState({ pollCommLoading: false });
      }, 500);
      let { data } = result;
      let { success, error, BundleID, communicationRequests } = data;

      if (success) {
        this.getAllVisits();
        if (communicationRequests && communicationRequests.length > 0) {
          this.handleAddCommunicationRequestInfo(communicationRequests);
        }
      } else {
        console.log("error in polling");
        console.log(error);
        console.log("----------");
      }
    }
  };
  handleAddCommunicationRequestInfo = async (communicationRequests) => {
    let Response = await axios.post(
      KayanURL + "api/KSA/RCM/patient/addCommunicationRequest",
      {
        data: communicationRequests,
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
      }
    );
    if (Response) {
      let { data } = Response;
      console.log(data);
      if (data) {
        if (data.success) {
          this.setState({ pollCommMsg: "Done" });
          setTimeout(() => {
            this.setState({ pollCommMsg: "" });
          }, 1000);
        } else {
          console.log(
            "error in update or add the authorization response of a visit:",
            data.error
          );
          this.setState({ success: false /* , error: data.error */ });
        }
      }
    }
  };
  handleDownload = (attachmentData, fileName) => {
    try {
      const binaryData = atob(attachmentData);
      const bytes = new Uint8Array(binaryData.length);
      for (let i = 0; i < binaryData.length; i++) {
        bytes[i] = binaryData.charCodeAt(i);
      }

      const blob = new Blob([bytes], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;

      link.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };
  render() {
    let {
      allvisits,
      costToBeneficiaryTypesValues,
      selectedVisit,
      editClaim,
      filteredPriceList,
      vitalSignSelectArray,
      allproceduresFlag,
      communicationError,
      allCommRequestInfo,
      allClaimsInfo
    } = this.state;
    console.log(this.state.claims, "claims forrrrrrrr batch")
    let visitRows, claimOption, commRequest;
    if (allvisits && allvisits.length > 0) {
      visitRows = allvisits.map((element, index) => {
        // console.log(element.claimsubmissionstatus, 'eee')
        let flag =false
        let visitStatus, claimsubmissionstatus, color;
        if (element.visitstatus === "1") {
          visitStatus = "Not Started";
        } else if (element.visitstatus === "2") {
          visitStatus = "Started";
        } else if (element.visitstatus === "3") {
          visitStatus = "Pending";
        } else if (element.visitstatus === "4") {
          visitStatus = " Ended";
        }
        if (element.claimsubmissionstatus === "1") {
          claimsubmissionstatus = "Pending";
          color = "grey";
          claimOption = "Claim";
        } else if (element.claimsubmissionstatus === "2") {
          claimsubmissionstatus = "Faild";
          color = "red";
          claimOption = "Claim";
        } else if (element.claimsubmissionstatus === "3") {
          claimsubmissionstatus = "Complete";
          color = "green";
          claimOption = "";
        } else if (element.claimsubmissionstatus === "4") {
          claimsubmissionstatus = "Queued";
          color = "yellow";
        } else if (element.claimsubmissionstatus === "cancelled") {
          claimsubmissionstatus = "Cancelled";
          color = "black";
        }
        let count = 0;
        if (allCommRequestInfo && allCommRequestInfo.length > 0) {
          if (allClaimsInfo && allClaimsInfo.length > 0) {
            let claimObject = allClaimsInfo.find(
              (x) => x.visitid === element.id
            );
            // console.log(claimObject, 'auth obj')
            if (claimObject) {
              commRequest = allCommRequestInfo.filter(
                (e) => e.communicationabout === claimObject.claimrequestidentifier
              );
              if (commRequest && commRequest.length > 0) {
                let countArray = commRequest.filter(
                  (e) => e.acknowledgmentstatus === "Not replyed yet"
                );
                count = countArray.length;
              }
            }

          }
        }
        console.log(commRequest, 'new')
        return (
          <TableRow key={index}>
            <TableCell align="center" style={{ fontSize: "small" }}>
              <Checkbox
                // checked={this.state.checkboxFlag}
                checked={this.state.claimSeq.includes(index + 1)}
                name="selectClaim"
                onChange={(e) =>
                  this.handleCheckBoxChange(e, element.id, index)
                }
              />
            </TableCell>

            <TableCell align="center" style={{ fontSize: "small" }}>
              <a
                style={{
                  cursor: "pointer",
                  width: "10px ",
                  height: "10px",
                  backgroundColor: color,
                  padding: "6px 9px",
                  borderRadius: "50%",
                  color: "white",
                }}
                onClick={() => this.getAllClaimInformation(element,flag)}
              >
                {element.id}
              </a>
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.identifier}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.firstname} {element.lastname}
            </TableCell>
            {/*   <TableCell align="center" style={{ fontSize: "small" }}>
              {element.invoicenumber}
            </TableCell> */}
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.insurancecompany}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {visitStatus}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.visitstartdate}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.visitenddate}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {claimsubmissionstatus}
            </TableCell>
            {commRequest && commRequest.length > 0 ? (
              <TableCell align="center" style={{ fontSize: "small" }}>
                {`(${count}) Communication Request Not Replyed Yet`}
              </TableCell>
            ) : null}
          </TableRow>
        );
      });
    }
    let costRows;
    if (
      costToBeneficiaryTypesValues &&
      costToBeneficiaryTypesValues.length > 0
    ) {
      costRows = costToBeneficiaryTypesValues.map((element, index) => {
        let keyOfElement = Object.keys(element)[0];
        return (
          <Typography
            id="modal-modal-title"
            key={index}
            sx={{ mt: 2 }}
            style={{ textTransform: "capitalize" }}
          >
            {keyOfElement} : {element[[keyOfElement]]}
          </Typography>
        );
      });
    }
    let procedureDiscount, procedurePrice, priceAfterDiscount, procedureTax;
    if (filteredPriceList && filteredPriceList.length > 0) {
      procedureDiscount = parseInt(filteredPriceList[0].discount);
      procedurePrice = parseInt(filteredPriceList[0].price);
      procedureTax = parseInt(
        (
          parseInt(filteredPriceList[0].price) *
          this.state.procedureQuantity *
          (1 - parseInt(filteredPriceList[0].discount) / 100) *
          0.15
        ).toFixed(2)
      );
      priceAfterDiscount =
        parseInt(filteredPriceList[0].price) *
        this.state.procedureQuantity *
        (1 - parseInt(filteredPriceList[0].discount) / 100);
    }
    let allDiagnosisRows = [];
    let allproceduresRows = [];
    let relatedDiagnosis;
    let supportingInformationTable = [];
    let totalSum = 0;
    let totalRows = []
    let AuthtotalRows = []
    if (selectedVisit) {
      let {
        allprocedures,
        diagnosis,
        supportinginformation,
        authorizationstatus,
        claimsubmissionstatus,
        totals,
        Authtotals
      } = selectedVisit;
      if (diagnosis && diagnosis.length > 0) {
        allDiagnosisRows = diagnosis.map((element, index) => {
          return (
            <TableRow key={index}>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {index + 1}{" "}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.type}{" "}
              </TableCell>

              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.code}{" "}
              </TableCell>

              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.description}{" "}
              </TableCell>
            </TableRow>
          );
        });
      }

      if (supportinginformation && supportinginformation.length > 0) {
        supportingInformationTable = supportinginformation.map(
          (info, index) => {
            let keys = Object.keys(info);
            let value;

            if (keys[0] == "chief-complaint") {
              value = info[keys[0]]["text"];
            } else if (keys[0] == "attachment") {
              value = info[keys[0]]["title"];
            } else {
              value = info[[keys[0]]];
            }

            return (
              <TableRow key={index}>
                <TableCell align="center" style={{ fontSize: "small" }}>
                  {index + 1}{" "}
                </TableCell>
                <TableCell align="center" style={{ fontSize: "small" }}>
                  {keys[0]}
                </TableCell>

                <TableCell align="center" style={{ fontSize: "small" }}>
                  {value}
                </TableCell>
                {editClaim ? (
                  <TableCell align="center" style={{ fontSize: "small" }}>
                    <a
                      onClick={() => {
                        this.handleDeleteVital(index);
                      }}
                    >
                      <DeleteIcon style={{ cursor: "pointer" }} />
                    </a>
                  </TableCell>
                ) : null}
              </TableRow>
            );
          }
        );
      }
      if (allprocedures && allprocedures.length > 0) {
        allproceduresRows = allprocedures.map((element, index) => {
          let { diagnosisSequence, informationSequence } = element;

          let { price, discount, tax, quantity, net } = element;
          if (element.outcome === "approved" || element.outcome === "partial")
            totalSum += parseFloat(net);
          relatedDiagnosis = [];
          if (
            diagnosisSequence &&
            diagnosisSequence.length > 0 &&
            diagnosis &&
            diagnosis.length > 0
          ) {
            diagnosisSequence.forEach((seq) => {
              relatedDiagnosis.push(diagnosis[[seq - 1]].code);
            });
          }
          return (
            <TableRow key={index}>
              <TableCell align="center">
                <Checkbox
                  checked={this.state.procedureSeq.includes(index + 1)}
                  disabled={this.state.editProcedure ? false : true}
                  name="selectProcedure"
                  onChange={(e) =>
                    this.handleCheckBoxChange(e, "", index)
                  }
                />
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small", textTransform: "capitalize" }}>
                {element.type}{" "}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.code}{" "}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small", textTransform: "capitalize" }}>
                {element.description}
              </TableCell>

              {editClaim ? (
                <TableCell align="center" style={{ fontSize: "small", width: "100%" }}>
                  <div style={{ fontSize: "small", width: "150px" }}>
                    <TextField
                      InputLabelProps={{
                        sx: { fontSize: "small" },
                      }}
                      required
                      value={element.invoice ? element.invoice : ""}
                      type="text"
                      name="invoice"
                      label="Invoice Number"
                      variant="outlined"
                      onChange={(e) =>
                        this.HandleProcedureChange(e, index)
                      }
                    />
                  </div>
                </TableCell>
              ) : (
                <TableCell align="center" style={{ fontSize: "small" }}>
                  {element.invoice}
                </TableCell>
              )}
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.quantity}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.price}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.discount}%
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.tax}
              </TableCell>

              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.deduction}%
              </TableCell>

              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.patientshare}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.net}
              </TableCell>

              {/**tooth */}

              {element.type == "dental" && element.toothNumber ? (
                <TableCell align="center" style={{ fontSize: "small" }}>
                  {
                    /* this.state.showToothNumber ? */ element.toothNumber +
                    "/" +
                    element.toothDescription /* : " " */
                  }
                </TableCell>
              ) : (
                <TableCell
                  align="center"
                  style={{ fontSize: "small" }}
                ></TableCell>
              )}

              {relatedDiagnosis && relatedDiagnosis.length > 0 ? (
                <TableCell align="center" style={{ fontSize: "small" }}>
                  {relatedDiagnosis.toString()}
                </TableCell>
              ) : (
                <TableCell
                  align="center"
                  style={{ fontSize: "small" }}
                ></TableCell>
              )}

              {informationSequence && informationSequence.length > 0 || editClaim ? (
                <>
                  {editClaim && this.state
                    .vitalSignSelectArray &&
                    this.state.vitalSignSelectArray
                      .length > 0 ? (
                    <TableCell align="center" style={{ fontSize: "small" }}>

                      <div
                        style={{
                          width: "100% ",
                          margin: "10px auto",
                        }}
                      >
                        <Multiselect
                          key={this.state.key}
                          placeholder="Supporting Informatiom"
                          options={
                            this.state
                              .vitalSignSelectArray
                          }
                          selectedValues={informationSequence ? selectedVisit.allprocedures[index].
                            informationSequence.map(sequence => vitalSignSelectArray[sequence - 1]) : null}
                          onSelect={(selectedList) => {
                            this.SelectCategoryForProcedure(selectedList, index);
                          }}
                          onRemove={(selectedList, removedItem) => {
                            this.RemoveCategoryForProcedure(selectedList, removedItem, index);
                          }
                          }
                          displayValue="display"
                        />
                      </div>
                    </TableCell>
                  ) : informationSequence && informationSequence.length > 0 ? (
                    <TableCell
                      align="center"
                      style={{ fontSize: "small" }}
                    >
                      {informationSequence.toString()}
                    </TableCell>
                  )
                    : (
                      <TableCell
                        align="center"
                        style={{ fontSize: "small" }}
                      ></TableCell>
                    )}
                </>
              ) : (
                <TableCell
                  align="center"
                  style={{ fontSize: "small" }}
                ></TableCell>
              )}

              {authorizationstatus && authorizationstatus == "3" ? (
                <TableCell align="center" style={{ fontSize: "small" }}>
                  <TableRow align="center">
                    <TableCell align="center" style={{ fontSize: "small" }}>
                      Outcome
                    </TableCell>
                    <TableCell align="center" style={{ fontSize: "small", textTransform: "capitalize" }}>
                      {element.outcome}
                    </TableCell>
                  </TableRow>

                  {authorizationstatus &&
                    authorizationstatus == "3" &&
                    (element.outcome == "rejected" ||
                      element.outcome == "partial") ? (
                    <TableRow>
                      <TableCell align="center" style={{ fontSize: "small" }}>
                        Rejection Reason
                      </TableCell>
                      <TableCell align="center" style={{ fontSize: "small", textTransform: "capitalize" }}>
                        {element.reason}
                      </TableCell>
                    </TableRow>
                  ) : null}

                  {authorizationstatus &&
                    authorizationstatus == "3" &&
                    (element.outcome == "rejected" ||
                      element.outcome == "partial") ? (
                    <TableRow>
                      <TableCell align="center" style={{ fontSize: "small" }}>
                        Denail Code
                      </TableCell>
                      <TableCell align="center" style={{ fontSize: "small" }}>
                        {element.denailCode}
                      </TableCell>
                    </TableRow>
                  ) : null}
                  {element.adjudications && element.adjudications.length > 0 ? (
                    <TableRow>
                      <TableCell
                        colSpan={2}
                        align="center"
                        style={{ fontSize: "small" }}
                      >
                        Adjudications Outcome
                      </TableCell>
                    </TableRow>
                  ) : null}

                  {element.adjudications && element.adjudications.length > 0
                    ? element.adjudications.map((adj, i) => {
                      return (
                        <>
                          <TableRow align="center" key={i}>
                            <TableCell
                              align="center"
                              style={{ fontSize: "small", textTransform: "capitalize" }}
                            >
                              {adj.category}
                            </TableCell>{" "}
                            <TableCell
                              align="center"
                              style={{ fontSize: "small" }}
                            >
                              {adj.amount}
                            </TableCell>
                          </TableRow>
                        </>
                      );
                    })
                    : null}
                </TableCell>
              ) : null}

              {claimsubmissionstatus && claimsubmissionstatus == "3" && element.claimSubmissionOutcome || (claimsubmissionstatus == "cancelled" && this.state.errorsRow.length == 0 && !this.state.queuedFlag) ? (
                <TableCell align="center" style={{ fontSize: "small" }}>
                  <TableRow align="center">
                    <TableCell align="center" style={{ fontSize: "small" }}>
                      Outcome
                    </TableCell>
                    <TableCell align="center" style={{ fontSize: "small", textTransform: "capitalize" }}>
                      {element.claimSubmissionOutcome}
                    </TableCell>
                  </TableRow>

                  {element.claimSubmissionOutcome == "rejected" ||
                    element.claimSubmissionOutcome == "partial" || ((claimsubmissionstatus == "cancelled" && this.state.errorsRow.length == 0 && !this.state.queuedFlag) && (element.claimSubmissionOutcome == "rejected" ||
                      element.claimSubmissionOutcome == "partial")) ? (
                    <TableRow>
                      <TableCell align="center" style={{ fontSize: "small" }}>
                        Rejection Reason
                      </TableCell>
                      <TableCell align="center" style={{ fontSize: "small", textTransform: "capitalize" }}>
                        {element.reason}
                      </TableCell>
                    </TableRow>
                  ) : null}

                  {element.claimSubmissionOutcome == "rejected" ||
                    element.claimSubmissionOutcome == "partial" || ((claimsubmissionstatus == "cancelled" && this.state.errorsRow.length == 0 && !this.state.queuedFlag) && (element.claimSubmissionOutcome == "rejected" ||
                      element.claimSubmissionOutcome == "partial")) ? (
                    <TableRow>
                      <TableCell align="center" style={{ fontSize: "small" }}>
                        Denail Code
                      </TableCell>
                      <TableCell align="center" style={{ fontSize: "small" }}>
                        {element.denailCode}
                      </TableCell>
                    </TableRow>
                  ) : null}
                  {element.claimSubmissionAdjudications &&
                    element.claimSubmissionAdjudications.length > 0 || (claimsubmissionstatus == "cancelled" && this.state.errorsRow.length == 0 && !this.state.queuedFlag) ? (
                    <TableRow>
                      <TableCell
                        colSpan={2}
                        align="center"
                        style={{ fontSize: "small" }}
                      >
                        Adjudications Outcome
                      </TableCell>
                    </TableRow>
                  ) : null}

                  {element.claimSubmissionAdjudications &&
                    element.claimSubmissionAdjudications.length > 0
                    ? element.claimSubmissionAdjudications.map((adj, i) => {
                      return (
                        <>
                          <TableRow align="center" key={i}>
                            <TableCell
                              align="center"
                              style={{ fontSize: "small", textTransform: "capitalize" }}
                            >
                              {adj.category}
                            </TableCell>{" "}
                            <TableCell
                              align="center"
                              style={{ fontSize: "small" }}
                            >
                              {adj.amount}
                            </TableCell>
                          </TableRow>
                        </>
                      );
                    })
                    : null}
                </TableCell>
              ) : null}
            </TableRow>
          );
        });
      }
      if (Authtotals && Authtotals.length > 0) {
        AuthtotalRows = Authtotals.map((adj, i) => {
          return (
            <TableRow key={i}>
              <TableCell
                align="center"
                style={{ fontSize: "small", textTransform: "capitalize" }}
              >
                {adj.category}
              </TableCell>{" "}
              <TableCell
                align="center"
                style={{ fontSize: "small" }}
              >
                {adj.amount}
              </TableCell>
            </TableRow>
          );
        })
      }
      if (totals && totals.length > 0) {
        totalRows = totals.map((adj, i) => {
          return (
            <TableRow key={i}>
              <TableCell
                align="center"
                style={{ fontSize: "small", textTransform: "capitalize" }}
              >
                {adj.category}
              </TableCell>{" "}
              <TableCell
                align="center"
                style={{ fontSize: "small" }}
              >
                {adj.amount}
              </TableCell>
            </TableRow>
          );
        })
      }
    }
    let communicationErrorsRow = []
    if (communicationError && communicationError.length > 0) {
      communicationErrorsRow = communicationError.map((element, index) => {
        return (
          <TableRow key={index}>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.message}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.expression}
            </TableCell>
          </TableRow>
        );
      });
    }
    return (
      <Box height={60}>
        <div>
          <div
            style={{
              textAlign: "center",
              margin: "auto",
              boxShadow: "1px solid grey",
              padding: "10px",
              boxShadow:
                "0px 2px 4px -1px rgba(0,0,0,0.3),0px 4px 5px 0px rgba(0,0,0,0.15),0px 1px 10px 0px rgba(0,0,0,0.11)",
              borderRadius: "10px",
              marginTop: "50px",
              width: "100%",
            }}
          >
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              style={{ textAlign: "left", marginLeft: "30px" }}
            >
              Claim Submission
            </Typography>
            <div
              style={{
                margin: "auto",
                boxShadow: "1px solid grey",
                padding: "10px",
                // boxShadow:
                //   "0px 2px 4px -1px rgba(0,0,0,0.3),0px 4px 5px 0px rgba(0,0,0,0.15),0px 1px 10px 0px rgba(0,0,0,0.11)",
                // borderRadius: "10px",
                marginTop: "10px",
                width: "95%",
              }}
            >
              <Accordion
                defaultActiveKey="0"
                style={{
                  margin: "auto",
                  paddingBottom: "20px",
                  width: "80%",
                }}
              >
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    <span style={{ color: "grey" }}>Search Claim</span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <Row>
                      <Col>
                        <FormControl fullWidth sx={{ mb: 3 }}>
                          <TextField
                            InputLabelProps={{ sx: { fontSize: "small" }, shrink: this.state.identifier ? true : false }}
                            inputProps={{ sx: { padding: "9px" } }}
                            name="identifier"
                            label="Identifier"
                            variant="outlined"
                            value={this.state.identifier}
                            onChange={this.HandleInputSearchRequestTextChange}
                          />
                        </FormControl>
                        <FormControl sx={{ mb: 3 }} style={{ width: "100%" }}>
                          <InputLabel
                            id="insurance"
                            style={{ fontSize: "small" }}
                          >
                            TPA
                          </InputLabel>
                          <Select
                            required
                            labelId="tpa"
                            name="tpa"
                            label="TPA"
                            onChange={this.HandleInputSearchRequestTextChange}
                            value={this.state.tpa ? this.state.tpa : ""}
                            style={{ height: "45px" }}
                          >
                            <MenuItem
                              value="7001463160"
                              name="GlobeMed"
                              style={{ fontSize: "small" }}
                            >
                              GlobeMed Saudi
                            </MenuItem>
                            <MenuItem
                              value="7001604342"
                              name="Mednet"
                              style={{ fontSize: "small" }}
                            >
                              Mednet
                            </MenuItem>

                            <MenuItem
                              value="7001599658"
                              name="Totalcare"
                              style={{ fontSize: "small" }}
                            >
                              Totalcare
                            </MenuItem>
                            <MenuItem
                              value="7001580856"
                              name="Nextcare"
                              style={{ fontSize: "small" }}
                            >
                              Nextcare
                            </MenuItem>
                          </Select>
                        </FormControl>

                        {/* <div style={{ width: "100%" }}>
                          <Button
                            variant="contained"
                            style={{
                              backgroundColor: "rgb(97 110 120",
                              marginRight: "10px",
                            }}
                            onClick={(e) => this.handleSearchRequest(e)}
                          >
                            search
                          </Button>
                          <Button
                            variant="contained"
                            style={{
                              backgroundColor: "rgb(97 110 120",
                              transition: "background-color 0.4s, color 0.4s",
                            }}
                            onClick={(e) => this.handlePollingRequest(e)}
                          >
                            {this.state.pollLoading ? 'Loading...' : ' Polling'}

                          </Button>
                        </div> */}
                      </Col>
                      <Col>
                        <FormControl fullWidth sx={{ mb: 3 }}>
                          <TextField
                            InputLabelProps={{ sx: { fontSize: "small" } }}
                            inputProps={{ sx: { padding: "9px" } }}
                            name="name"
                            label="Patient Name"
                            value={this.state.name ? this.state.name : ""}
                            variant="outlined"
                            onChange={this.HandleInputSearchRequestTextChange}
                          />
                        </FormControl>
                        <FormControl fullWidth sx={{ mb: 3 }}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              sx={{
                                "& .MuiInputBase-input": {
                                  height: "8px",
                                },
                                ".css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root": {
                                  fontSize: "small",
                                }
                              }
                              }
                              name="visitstartdate"
                              label="Start Date"
                              value={this.state.visitstartdate ? this.state.visitstartdate : ""}
                              onChange={(date) =>
                                this.HandleDateChange({
                                  name: "visitstartdate",
                                  value: date,
                                })
                              }
                            />
                          </LocalizationProvider>
                        </FormControl>
                      </Col>
                      <Col>
                        <FormControl sx={{ mb: 3 }} style={{ width: "100%" }}>
                          <InputLabel
                            id="insurance"
                            style={{ fontSize: "small" }}
                          >
                            Insurance Company
                          </InputLabel>
                          <Select
                            required
                            labelId="insurance"
                            name="payerid"
                            label="Insurance Company"
                            value={this.state.payerid ? this.state.payerid : ""}
                            onChange={this.HandleInputSearchRequestTextChange}
                            style={{ height: "45px" }}
                          >
                            <MenuItem
                              value="INS-FHIR"
                              name="Pseudo Payer"
                              style={{ fontSize: "small" }}
                            >
                              Pseudo Payer
                            </MenuItem>
                            <MenuItem
                              value="7001571327"
                              style={{ fontSize: "small" }}
                            >
                              Bupa Arabia for Cooperative Insurance
                            </MenuItem>
                            <MenuItem
                              value="7000911508"
                              style={{ fontSize: "small" }}
                            >
                              The Cooperative Company for Cooperative Insurance
                            </MenuItem>
                            <MenuItem
                              value="7001593321"
                              style={{ fontSize: "small" }}
                            >
                              Al-Rajhi Company for Cooperative Insurance
                            </MenuItem>
                            <MenuItem
                              value="7001548317"
                              style={{ fontSize: "small" }}
                            >
                              The Mediterranean and Gulf Cooperative Insurance and
                              Reinsurance Company (MedGulf)
                            </MenuItem>
                            <MenuItem
                              value="7001539720"
                              style={{ fontSize: "small" }}
                            >
                              Saudi Arabian Cooperative Insurance Company (SAICO) *
                            </MenuItem>
                            <MenuItem
                              value="7001532279"
                              style={{ fontSize: "small" }}
                            >
                              Gulf Union Cooperative Insurance Company
                            </MenuItem>
                            <MenuItem
                              value="7001607683"
                              style={{ fontSize: "small" }}
                            >
                              AXA Cooperative Insurance Company
                            </MenuItem>
                            <MenuItem
                              value="7001519912"
                              style={{ fontSize: "small" }}
                            >
                              Malath Cooperative Insurance and Reinsurance Company
                            </MenuItem>
                            <MenuItem
                              value="7001527667"
                              style={{ fontSize: "small" }}
                            >
                              Arabia Insurance Cooperative Company
                            </MenuItem>
                            <MenuItem
                              value="7001523724"
                              style={{ fontSize: "small" }}
                            >
                              Salama Cooperative Insurance Company
                            </MenuItem>
                            <MenuItem
                              value="7001703672"
                              style={{ fontSize: "small" }}
                            >
                              Saudi Enaya Cooperative Insurance Company
                            </MenuItem>
                            <MenuItem
                              value="7001625891"
                              style={{ fontSize: "small" }}
                            >
                              Solidarity Saudi Takaful Company
                            </MenuItem>
                            <MenuItem
                              value="7001626717"
                              style={{ fontSize: "small" }}
                            >
                              Amana Cooperative Insurance Company *
                            </MenuItem>
                            <MenuItem
                              value="7001534275"
                              style={{ fontSize: "small" }}
                            >
                              The National Company for Cooperative Insurance
                            </MenuItem>
                            <MenuItem
                              value="7001537161"
                              style={{ fontSize: "small" }}
                            >
                              Allianz Saudi Fransi Cooperative Insurance Company
                            </MenuItem>
                            <MenuItem
                              value="7001526578"
                              style={{ fontSize: "small" }}
                            >
                              Saudi United Cooperative Insurance Company (Wala)
                            </MenuItem>
                            <MenuItem
                              value="7001535694"
                              style={{ fontSize: "small" }}
                            >
                              Allied Cooperative Insurance Group (ACIG)
                            </MenuItem>
                            <MenuItem
                              value="7001609481"
                              style={{ fontSize: "small" }}
                            >
                              Global Company for Cooperative Insurance
                            </MenuItem>
                            <MenuItem
                              value="7001641419"
                              style={{ fontSize: "small" }}
                            >
                              Gulf General Company for Cooperative Insurance
                            </MenuItem>
                            <MenuItem
                              value="7001544472"
                              style={{ fontSize: "small" }}
                            >
                              Al Sagr Cooperative Insurance Company *
                            </MenuItem>
                            <MenuItem
                              value="7001549059"
                              style={{ fontSize: "small" }}
                            >
                              Trade Union Cooperative Insurance Company *
                            </MenuItem>
                            <MenuItem
                              value="7001617724"
                              style={{ fontSize: "small" }}
                            >
                              Buruj Cooperative Insurance Company *
                            </MenuItem>
                            <MenuItem
                              value="7001527816"
                              style={{ fontSize: "small" }}
                            >
                              Arabian Shield Cooperative Insurance Company *
                            </MenuItem>
                            <MenuItem
                              value="7001559389"
                              style={{ fontSize: "small" }}
                            >
                              United Cooperative Insurance Company
                            </MenuItem>
                            <MenuItem
                              value="7001727200"
                              style={{ fontSize: "small" }}
                            >
                              Tokyo Marine Development Corporation
                            </MenuItem>

                          </Select>
                        </FormControl>
                        <FormControl fullWidth sx={{ mb: 3 }}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              sx={{
                                "& .MuiInputBase-input": {
                                  height: "8px",
                                },
                                ".css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root": {
                                  fontSize: "small",
                                }
                              }
                              }
                              name="visitenddate"
                              label="End Date"
                              value={this.state.visitenddate ? this.state.visitenddate : ""}
                              onChange={(date) =>
                                this.HandleDateChange({
                                  name: "visitenddate",
                                  value: date,
                                })
                              }
                            />
                          </LocalizationProvider>
                        </FormControl>

                      </Col>
                    </Row>
                    <div style={{ width: "100%", display: "flex" }}>
                      <Button
                        variant="contained"
                        style={{
                          backgroundColor: "rgb(97 110 120",
                          marginRight: "10px",
                          width: "20%",
                          fontSize: "11px"

                        }}
                        onClick={(e) => this.handleSearchRequest(e)}
                      >
                        search
                      </Button>
                      <Button
                        variant="contained"
                        style={{
                          backgroundColor: "rgb(97 110 120",
                          transition: "background-color 0.4s, color 0.4s",
                          width: "30%",
                          marginRight: "10px",
                          fontSize: "10px"

                        }}
                        onClick={(e) => this.handlePollingRequest(e)}
                      >
                        {this.state.pollLoading ? "Loading..." : " Claim Submission Response Polling"}
                      </Button>
                      <Button
                        variant="contained"
                        style={{
                          backgroundColor: "rgb(97 110 120",
                          transition: "background-color 0.4s, color 0.4s",
                          width: "20%",
                          fontSize: "11px"

                        }}
                        onClick={(e) => this.handlePollingCommunicationRequest(e)}
                      >
                        {this.state.pollCommLoading ? "Loading..." : "Comm_Req Poll"}
                      </Button>

                    </div>
                    {this.state.pollCommMsg ? (
                      <>
                        <Typography
                          id="modal-modal-title"
                          variant="h6"
                          component="h2"
                          style={{ textAlign: "center", marginTop: "20px", color: "green", fontSize: "17px" }}
                        >
                          {this.state.pollCommMsg}
                        </Typography>
                      </>
                    ) : null}
                    {this.state.errMsg ? (
                      <>
                        <Typography style={{ textAlign: "center", color: "red" }}>
                          {this.state.errMsg}
                        </Typography>
                      </>
                    ) : null}
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
              {this.state.batchSubmissionFlag ? (
                <div
                  style={{ width: "50%", textAlign: "center", margin: "auto" }}
                >
                  <Button
                    variant="primary"
                    type="submit"
                    onClick={(e) => this.handleSubmitBatch(e)}
                    style={{
                      width: "45%",
                      marginTop: "32px",
                      padding: "7px",
                      backgroundColor: "rgb(97 110 120",
                      border: "1px solid rgb(97 110 120",
                      color: "white",
                      transition: "background-color 0.4s, color 0.4s",
                    }}
                  >
                    {this.state.batchLoading ? 'Loading...' : "Batch Submission"}
                  </Button>
                </div>
              ) : null}
              {this.state.batchError ? (<>
                <Stack style={{ width: "fit-content" }}>
                  <Alert severity="error">
                    {this.state.batchError}
                  </Alert>
                </Stack>
              </>) : null}
              {this.state.InvoiceNumberError ? (<>
                <Stack style={{ width: "fit-content" }}>
                  <Alert severity="error">
                    {this.state.InvoiceNumberError}
                  </Alert>
                </Stack>
              </>) : null}
              {this.state.allvisits && this.state.allvisits.length > 0 ? (
                <>
                  <TableContainer
                    key={this.state.Claimskey}
                    component={Paper}
                    style={{ margin: "20px auto 20px" }}
                  >
                    <Table aria-label="simple table">
                      <TableHead style={{ backgroundColor: "#fafafa" }}>
                        <TableRow style={{ textAlign: "center" }}>
                          <TableCell
                            align="center"
                            style={{ fontSize: "small" }}
                          >
                            <Checkbox
                              checked={this.state.checkAll}
                              onChange={(e) => this.handleCheckBoxChange(e)}
                              name="selectAll"
                            />
                          </TableCell>
                          <TableCell align="center">Visit Number</TableCell>
                          <TableCell align="center">Patient Identifier</TableCell>
                          <TableCell align="center">Name</TableCell>
                          {/*   <TableCell align="center">Invoice Number</TableCell> */}
                          <TableCell align="center">Insurance</TableCell>
                          <TableCell align="center">Visit Status</TableCell>
                          <TableCell align="center">Visit Start Date</TableCell>
                          <TableCell align="center">Visit End Date</TableCell>
                          <TableCell align="center">
                            Claim Submission Status
                          </TableCell>
                          {this.state.commRequestExist? (
                            <TableCell align="center">Communication Request</TableCell>
                          ) : null}
                        </TableRow>
                      </TableHead>
                      <TableBody>{visitRows}</TableBody>
                    </Table>
                  </TableContainer>
                </>
              ) : (
                <>
                  <Typography
                    id="modal-modal-title"
                    variant="h6"
                    component="h2"
                    style={{ textAlign: "center", marginTop: "30px" }}
                  >
                    There are no claims need submission!
                  </Typography>
                </>
              )}


              {this.state.viewClaimSubmissionInfoModal ? (
                <>
                  <Modal
                    open={this.state.viewClaimSubmissionInfoModal}
                    onClose={this.handleCloseClaimInfo}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <Box
                      sx={style}
                      style={{
                        width: "95%",
                        height: "600px",
                        overflowY: "scroll",
                      }}
                    >
                      <Row style={{ marginTop: "10px" }}>
                        <Col xs={2}>
                          {" "}
                          <Button
                            variant="contained"
                            style={{
                              backgroundColor: "rgb(97 110 120",
                              border: "1px ridge gray",
                              width: "70%",
                              color: "white",
                              fontSize: "smaller",
                              margin: "auto",
                              transition: "background-color 0.4s, color 0.4s",
                              width: "100%"
                            }}
                            onClick={(e) => {
                              this.setState({
                                editClaim: true,
                                AddDiagnosis:
                                  selectedVisit["diagnosis"] &&
                                    selectedVisit["diagnosis"].length > 0
                                    ? false
                                    : true,
                                addProcedure:
                                  selectedVisit["allprocedures"] &&
                                    selectedVisit["allprocedures"].length > 0
                                    ? false
                                    : true,
                                addVital:
                                  selectedVisit["supportinginformation"] &&
                                    selectedVisit["supportinginformation"]
                                      .length > 0
                                    ? false
                                    : true,
                              });
                              this.handleSave(e);
                            }}
                          >

                            {editClaim ? this.state.saveLoading ? 'Loading...' : "save" : "Edit"}
                          </Button>
                        </Col>
                        <Col xs={2}>
                          {" "}
                          {true ? (
                            <Button
                              variant="contained"
                              style={{
                                backgroundColor: "rgb(97 110 120)",
                                border: "1px ridge gray",

                                color: "white",
                                fontSize: "smaller",
                                margin: "auto",
                                transition: "background-color 0.4s, color 0.4s",
                                width: "100%"
                              }}
                              onClick={(e) =>
                                this.ClaimSubmissionRequest(e, selectedVisit)
                              }
                            >
                              {this.state.submitLoading ? 'Loading...' : ' Submit'}

                            </Button>
                          ) : /* (
                            <Button
                              variant="contained"
                              disabled
                              style={{
                                backgroundColor: "#d0dae2",
                                border: "1px ridge #d0dae2",

                                color: "white",
                                fontSize: "smaller",
                                margin: "auto",
                              }}
                            >
                              Approval Request
                            </Button>
                          ) */ null}
                        </Col>
                        {selectedVisit.claimsubmissionstatus !== "1" ? (<>

                          <Col xs={2}>
                            <Button
                              disabled={selectedVisit.claimsubmissionstatus === "1" || selectedVisit.claimsubmissionstatus === "cancelled" ? true : false}
                              variant="contained"
                              style={{
                                backgroundColor: selectedVisit.claimsubmissionstatus === "1" || selectedVisit.claimsubmissionstatus === "cancelled" ? "rgb(171 184 194)" : "rgb(97 110 120",
                                border: selectedVisit.claimsubmissionstatus === "1" || selectedVisit.claimsubmissionstatus === "cancelled" ? "1px ridge rgb(171 184 194)" : "1px ridge rgb(97 110 120",
                                cursor: "pointer",
                                color: "white",
                                fontSize: "smaller",
                                textAlign: "left",
                                transition: "background-color 0.4s, color 0.4s",
                                width: "100%"
                              }}
                              onClick={(e) =>
                                this.handleCansulation(e, selectedVisit)
                              }
                            >
                              {this.state.cancelLoading ? 'Loading...' : 'Cancellation'}
                            </Button>
                            {this.state.cancelErrors && this.state.cancelErrors.length > 0 ? (
                              <>
                                <h6 style={{ fontSize: "12px", color: "red", margin: "5px auto" }}>{this.state.cancelErrors[0].errorMsg}</h6>
                              </>
                            ) : null}
                          </Col>
                        </>) : null}
                        {selectedVisit.claimsubmissionstatus !== "1" ? (<>
                          <Col xs={2}>
                            <Button
                              variant="contained"
                              style={{
                                backgroundColor: "rgb(97 110 120",
                                border: "1px ridge rgb(97 110 120",
                                cursor: "pointer",
                                color: "white",
                                fontSize: "smaller",
                                textAlign: "left",
                                transition: "background-color 0.4s, color 0.4s",
                                width: "100%"
                              }}
                              onClick={(e) =>
                                this.handleCheck(e, selectedVisit)
                              }
                            >
                              {this.state.statusLoading ? 'Loading...' : 'Check Status'}
                            </Button>
                          </Col>
                        </>) : null}
                        {selectedVisit.claimsubmissionstatus !== "1" ? (<>
                          <Col xs={3}>
                            <Button
                              variant="contained"
                              style={{
                                backgroundColor: "rgb(97 110 120",
                                border: "1px ridge gray",
                                width: "100%",
                                color: "white",
                                fontSize: "smaller",
                                textAlign: "left",
                              }}
                              onClick={() => {
                                this.setState({
                                  communicationHistoryModalOpen: true
                                });
                                this.getAllCommunicationRequestInfoByReqIdentefier();
                                this.getAllCommunicationTransactionInfoByReqIdentefier()

                              }
                              }
                            >
                              Communication History
                            </Button>
                          </Col>
                        </>) : null}
                      </Row>
                      {this.state.communicationHistoryModalOpen ? (
                        <>
                          <Modal
                            open={this.state.communicationHistoryModalOpen}
                            onClose={this.handleCloseCommunicationHistoryModal}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                          >
                            <Box
                              sx={styleModal}
                              style={{
                                width: "70%",
                                height: "600px",
                                overflowY: "auto"
                              }}
                            >
                              <Row>
                                <Typography
                                  id="modal-modal-title"
                                  variant="h6"
                                  component="h2"
                                  style={{ textAlign: "left", marginTop: "5px" }}
                                >
                                  Communication Requests
                                </Typography>
                                {this.state.communicationRequestLoading ? (
                                  <div style={{ textAlign: "center" }}>
                                    <CircularProgress />
                                  </div>
                                ) : this.state.communicationReqSuccess &&
                                  this.state.requestData && this.state.requestData.length > 0 ? (
                                  <>
                                    <TableContainer
                                      component={Paper}
                                      style={{
                                        margin: "auto",
                                        width: "100%",
                                        // height: "300px",
                                        overflowY: "auto"
                                      }}
                                    >
                                      <Table aria-label="simple table">
                                        <TableHead style={{ backgroundColor: "#fafafa" }}>
                                          <TableRow style={{ textAlign: "center" }}>
                                            <TableCell align="center">
                                              ID
                                            </TableCell>
                                            <TableCell align="center">
                                              Communication Request Identifier
                                            </TableCell>
                                            <TableCell align="center">
                                              Communication Category
                                            </TableCell>
                                            <TableCell align="center">
                                              Communication About
                                            </TableCell>
                                            <TableCell align="center">
                                              Content String
                                            </TableCell>
                                            <TableCell align="center">
                                              Acknowledgment Status
                                            </TableCell>
                                            <TableCell align="center">
                                              Reply
                                            </TableCell>
                                          </TableRow>
                                        </TableHead>
                                        <TableBody>
                                          {this.state.requestData.map((ele, index) => {
                                            return (
                                              <TableRow>
                                                <TableCell align="center">
                                                  {ele.id}
                                                </TableCell>
                                                <TableCell align="center" style={{ textTransform: "capitalize" }}>
                                                  {ele.identifier}
                                                </TableCell>
                                                <TableCell align="center" style={{ textTransform: "capitalize" }}>
                                                  {ele.communicationcategory}
                                                </TableCell>
                                                <TableCell align="center" style={{ textTransform: "capitalize" }}>
                                                  {ele.communicationabout}
                                                </TableCell>
                                                <TableCell align="center" style={{ textTransform: "capitalize" }}>
                                                  {ele.contentstring}
                                                </TableCell>
                                                <TableCell align="center" style={{ textTransform: "capitalize" }}>
                                                  {ele.acknowledgmentstatus}
                                                </TableCell>
                                                <TableCell align="center">
                                                  <a
                                                    style={{ cursor: "pointer" }}
                                                    onClick={(e) => {
                                                      this.setState({
                                                        communicationModalOpen: true,
                                                        communicationCategory: ele.communicationcategory,
                                                        basedOnValue: ele.identifier,
                                                        communicationAboutValue: ele.communicationabout,
                                                        idValue: ele.id
                                                      });

                                                    }
                                                    }
                                                  >
                                                    <ReplyIcon style={{ color: "#6262e7" }} />
                                                  </a>
                                                </TableCell>
                                              </TableRow>
                                            )

                                          })}

                                        </TableBody>
                                      </Table>
                                    </TableContainer>
                                  </>
                                ) : (
                                  <>
                                    <p
                                      style={{
                                        color: "red",
                                        textAlign: "center",
                                        fontSize: "13px",
                                      }}
                                    >
                                      There is no communication requests !
                                    </p>
                                  </>
                                )}
                              </Row>
                              <hr />
                              <Row>
                                <Typography
                                  id="modal-modal-title"
                                  variant="h6"
                                  component="h2"
                                  style={{ textAlign: "left", marginTop: "5px" }}
                                >
                                  Communication Transactions
                                </Typography>
                                <div style={{ width: "30%", marginLeft: "auto" }}>
                                  <Button
                                    variant="contained"
                                    style={{
                                      backgroundColor: "rgb(97 110 120",
                                      border: "1px ridge gray",
                                      width: "100%",
                                      color: "white",
                                      fontSize: "smaller",
                                      textAlign: "left",
                                      fontSize: "11px",
                                    }}
                                    onClick={(e) => {
                                      this.setState({
                                        communicationModalOpen: true
                                      });

                                    }
                                    }
                                  >
                                    Send Unsolicited Communication 
                                  </Button>
                                </div>
                                {this.state.communicationTransactionLoading ? (
                                  <div style={{ textAlign: "center" }}>
                                    <CircularProgress />
                                  </div>
                                ) : this.state.communicationTransactionSuccess &&
                                  this.state.transactionsData && this.state.transactionsData.length > 0 ? (
                                  <>
                                    <TableContainer
                                      component={Paper}
                                      style={{
                                        margin: "10px auto",
                                        width: "100%",
                                        // height: "300px",
                                        overflowY: "auto"
                                      }}
                                    >
                                      <Table aria-label="simple table">
                                        <TableHead style={{ backgroundColor: "#fafafa" }}>
                                          <TableRow style={{ textAlign: "center" }}>
                                            <TableCell align="center">
                                              ID
                                            </TableCell>
                                            <TableCell align="center">
                                              Request Identifier
                                            </TableCell>
                                            <TableCell align="center">
                                              Communication Category
                                            </TableCell>
                                            <TableCell align="center">
                                              Content
                                            </TableCell>
                                            <TableCell align="center">
                                              Communication Type
                                            </TableCell>
                                            <TableCell align="center">
                                              Acknowledgment Status
                                            </TableCell>
                                            <TableCell align="center">
                                              Based On
                                            </TableCell>
                                            <TableCell align="center">
                                              Attachment
                                            </TableCell>
                                            <TableCell align="center">
                                              Error
                                            </TableCell>

                                          </TableRow>
                                        </TableHead>
                                        <TableBody>
                                          {this.state.transactionsData.map((ele, index) => {
                                            return (
                                              <TableRow>
                                                <TableCell align="center">
                                                  {ele.id}
                                                </TableCell>
                                                <TableCell align="center" style={{ textTransform: "capitalize" }}>
                                                  {ele.requestidentifier}
                                                </TableCell>
                                                <TableCell align="center" style={{ textTransform: "capitalize" }}>
                                                  {ele.communicationcategory}
                                                </TableCell>
                                                <TableCell align="center" style={{ textTransform: "capitalize" }}>
                                                  {ele.content}
                                                </TableCell>
                                                <TableCell align="center" style={{ textTransform: "capitalize" }}>
                                                  {ele.communicationtype}
                                                </TableCell>
                                                <TableCell align="center" style={{ textTransform: "capitalize" }}>
                                                  {ele.acknowledgmentstatus}
                                                </TableCell>
                                                <TableCell align="center" style={{ textTransform: "capitalize" }}>
                                                  {ele.basedon}
                                                </TableCell>
                                                <TableCell align="center">
                                                  {ele.attachment ? (
                                                    <a
                                                      href="#"
                                                      onClick={(e) => {
                                                        e.preventDefault();
                                                        this.handleDownload(ele.attachment, 'attachment.pdf');
                                                      }}
                                                      style={{ cursor: "pointer" }}
                                                    >
                                                      <FileDownloadIcon style={{ color: "#6262e7" }} />
                                                    </a>
                                                  ) : null}
                                                </TableCell>
                                                {ele.communicationerror && ele.communicationerror.length > 0 ? (
                                                  <TableCell align="center" style={{ textTransform: "capitalize" }}>
                                                    <a
                                                      style={{ cursor: "pointer" }}
                                                      onClick={(e) => {
                                                        this.setState({
                                                          showError: true,
                                                          communicationTransactionErrors: ele.communicationerror
                                                        });

                                                      }
                                                      }
                                                    >
                                                      <VisibilityIcon style={{ color: "#6262e7" }} />
                                                    </a>
                                                  </TableCell>
                                                ) : (
                                                  <TableCell >

                                                  </TableCell>
                                                )}

                                              </TableRow>
                                            )

                                          })}

                                        </TableBody>
                                      </Table>
                                    </TableContainer>
                                  </>
                                ) : (
                                  <>
                                    <p
                                      style={{
                                        color: "red",
                                        textAlign: "center",
                                        fontSize: "13px",
                                      }}
                                    >
                                      There is no communication transactions !
                                    </p>
                                  </>
                                )}
                              </Row>
                            </Box>
                          </Modal>
                        </>
                      ) : null}
                      {this.state.communicationModalOpen ? (
                        <>
                          <Modal
                            open={this.state.communicationModalOpen}
                            onClose={this.handleCloseCommunicationModal}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                          >
                            <Box
                              sx={styleModal}
                              style={{
                                width: "40%",
                                height: this.state.communicationError && this.state.communicationError.length > 0 ? "600px" : "400px",

                              }}
                            >
                              <div style={{ width: "70%", margin: "auto" }}>
                                <FormControl style={{ width: "100%" }}>
                                  <InputLabel
                                    id="Category"
                                    style={{ fontSize: "small" }}
                                  >
                                    Category
                                  </InputLabel>
                                  <Select
                                    required
                                    labelId="Category"
                                    name="communicationCategory"
                                    label="Category"
                                    onChange={this.HandleCommunicationInputChange}
                                    style={{ height: "45px" }}
                                    value={this.state.communicationCategory ? this.state.communicationCategory : ""}
                                  >
                                    <MenuItem
                                      value="alert"
                                      style={{ fontSize: "small" }}
                                    >
                                      Alert
                                    </MenuItem>
                                    <MenuItem
                                      value="notification"
                                      style={{ fontSize: "small" }}
                                    >
                                      Notification
                                    </MenuItem>
                                    <MenuItem
                                      value="reminder"
                                      style={{ fontSize: "small" }}
                                    >
                                      Reminder
                                    </MenuItem>
                                    <MenuItem
                                      value="instruction"
                                      style={{ fontSize: "small" }}
                                    >
                                      Instruction
                                    </MenuItem>
                                  </Select>
                                </FormControl>
                                <FormControl style={{ marginTop: "20px", width: "100%" }}>
                                  <TextField
                                    InputLabelProps={{ sx: { fontSize: "small" } }}
                                    inputProps={{ sx: { padding: "10px" } }}
                                    type="text"
                                    name="content"
                                    label="Content"
                                    variant="outlined"
                                    multiline
                                    maxRows={4}
                                    value={this.state.content ? this.state.content : ""}
                                    onChange={this.HandleCommunicationInputChange}
                                  />
                                </FormControl>
                                <div style={{ marginTop: "20px", border: "1px solid grey", padding: "10px", borderRadius: "5px" }}>
                                  <input
                                    style={{
                                      display: "block",
                                      margin: "auto",
                                      marginRight: "5px",
                                    }}
                                    type="file"
                                    name="communicationAttachment"
                                    ref={this.fileInputRef}
                                    onChange={this.HandleCommunicationInputChange}
                                  />
                                </div>

                              </div>

                              <Row>
                                <div style={{ width: "100%", marginTop: "20px", textAlign: "center" }}>
                                  <Button
                                    variant="contained"
                                    style={{
                                      backgroundColor: "rgb(97 110 120",
                                      marginRight: "10px",
                                      transition: "background-color 0.4s, color 0.4s",
                                      width: "20%",
                                    }}
                                    onClick={(e) => this.handleSend(e)}
                                  >
                                    {this.state.sendLoading
                                      ? "Loading..."
                                      : "Send"}
                                  </Button>

                                  <div>
                                  </div>
                                </div>
                              </Row>
                              <Row>
                                {(this.state.communicationError &&
                                  this.state.communicationError.length > 0) ? (
                                  <>
                                    <Typography
                                      id="modal-modal-title"
                                      variant="h6"
                                      component="h2"
                                      style={{ textAlign: "center", marginTop: "10px" }}
                                    >
                                      Errors
                                    </Typography>
                                    <div
                                      style={{
                                        width: "100%",
                                        margin: "auto",
                                        height: "200px",
                                        overflowY: "auto"
                                      }}
                                    >
                                      <TableContainer
                                        component={Paper}
                                        style={{
                                          margin: "auto",
                                          width: "100%",
                                        }}
                                      >
                                        <Table aria-label="simple table">
                                          <TableHead style={{ backgroundColor: "#fafafa" }}>
                                            <TableRow style={{ textAlign: "center" }}>
                                              <TableCell align="center">
                                                Message
                                              </TableCell>
                                              <TableCell align="center">
                                                Expression
                                              </TableCell>
                                            </TableRow>
                                          </TableHead>
                                          <TableBody>{communicationErrorsRow}</TableBody>
                                        </Table>
                                      </TableContainer>
                                    </div>
                                  </>
                                ) : this.state.acknowledgmentStatus === "ok" ? (
                                  <>
                                    <Typography
                                      id="modal-modal-title"
                                      variant="h6"
                                      component="h2"
                                      style={{ textAlign: "center", marginTop: "5px", color: "green", fontSize: "13px" }}
                                    >
                                      The Communication Transaction Sent Successfully

                                    </Typography>
                                  </>
                                ) : null}
                              </Row>
                            </Box>
                          </Modal>
                        </>
                      ) : null}
                      {this.state.showError ? (
                        <>
                          <Modal
                            open={this.state.showError}
                            onClose={this.handleCloseErrorModal}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                          >
                            <Box
                              sx={styleModal}
                              style={{
                                width: "50%",
                                height: "500px",
                                overflowY: "auto"
                              }}
                            >

                              <Row>
                                {(this.state.communicationTransactionErrors &&
                                  this.state.communicationTransactionErrors.length > 0) ? (
                                  <>
                                    <Typography
                                      id="modal-modal-title"
                                      variant="h6"
                                      component="h2"
                                      style={{ textAlign: "center", marginTop: "10px" }}
                                    >
                                      Errors
                                    </Typography>
                                    <div
                                      style={{
                                        width: "100%",
                                        margin: "auto",

                                        overflowY: "auto"
                                      }}
                                    >
                                      <TableContainer
                                        component={Paper}
                                        style={{
                                          margin: "auto",
                                          width: "100%",
                                        }}
                                      >
                                        <Table aria-label="simple table">
                                          <TableHead style={{ backgroundColor: "#fafafa" }}>
                                            <TableRow style={{ textAlign: "center" }}>
                                              <TableCell align="center">
                                                Message
                                              </TableCell>
                                              <TableCell align="center">
                                                Expression
                                              </TableCell>
                                            </TableRow>
                                          </TableHead>
                                          <TableBody>
                                            {this.state.communicationTransactionErrors.map((ele, index) => {
                                              return (
                                                <TableRow>
                                                  <TableCell align="center" style={{ textTransform: "capitalize" }}>
                                                    {ele.message}
                                                  </TableCell>
                                                  <TableCell align="center" style={{ textTransform: "capitalize" }}>
                                                    {ele.expression}
                                                  </TableCell>
                                                </TableRow>
                                              )

                                            })}
                                          </TableBody>
                                        </Table>
                                      </TableContainer>
                                    </div>
                                  </>
                                ) : null}
                              </Row>
                            </Box>
                          </Modal>
                        </>
                      ) : null}
                      <hr />

                      <Row>
                        <Col xs={3}>
                          <div>
                            <label style={{ fontWeight: "bold" }}>
                              Medical File:{" "}
                            </label>
                            {selectedVisit.medicalfilenumber}</div>
                          <div style={{ textTransform: "capitalize" }}>
                            <label style={{ fontWeight: "bold" }}>
                              Gender:{" "}
                            </label>
                            {selectedVisit.gender}</div>
                          <div style={{ textTransform: "capitalize" }}>
                            <label style={{ fontWeight: "bold" }}>
                              Claim Type:{" "}
                            </label>
                            {selectedVisit.claimtype}</div>
                        </Col>

                        <Col xs={3}>
                          <div style={{ textTransform: "capitalize" }}>
                            <label style={{ fontWeight: "bold" }}>
                              Patient Name:{" "}
                            </label>
                            {selectedVisit.firstname}{" "}
                            {selectedVisit.lastname}
                          </div>
                          <div>
                            <label style={{ fontWeight: "bold" }}>
                              Nationality:{" "}
                            </label>
                            {selectedVisit.nationality}</div>
                          <div>
                            <label style={{ fontWeight: "bold" }}>
                              Visit Start Date:{" "}
                            </label>
                            {selectedVisit.visitstartdate}
                          </div>
                        </Col>

                        <Col xs={3}>
                          <div>
                            <label style={{ fontWeight: "bold" }}>
                              Birthdate:{" "}
                            </label>
                            {selectedVisit.birthdate}</div>
                          <div style={{ textTransform: "capitalize" }}>
                            <label style={{ fontWeight: "bold" }}>
                              Visit Type:{" "}
                            </label>
                            {selectedVisit.visittype}</div>

                          <div>
                            <label style={{ fontWeight: "bold" }}>
                              Visit End Date:{" "}
                            </label>
                            {selectedVisit.visitenddate}
                          </div>
                        </Col>

                        <Col xs={3}>
                          <div>
                            <label style={{ fontWeight: "bold" }}>
                              Age:{" "}
                            </label>
                            {selectedVisit.age}</div>
                          <div style={{ textTransform: "capitalize" }}>
                            <label style={{ fontWeight: "bold" }}>
                              Doctor:{" "}
                            </label>
                            {selectedVisit.doctorName}</div>


                        </Col>
                      </Row>
                      {selectedVisit.eligibilityresponseidentifier ? (
                        <>
                          <hr />
                          <Row>
                            <Col xs={12}>
                              {selectedVisit.tpa ? (
                                <div style={{ textTransform: "capitalize" }}>
                                  <label style={{ fontWeight: "bold" }}>
                                    TPA:{" "}
                                  </label>
                                  {" "}
                                  {allTPA[selectedVisit.tpa]}
                                </div>
                              ) : null}

                              <div style={{ textTransform: "capitalize" }}>
                                <label style={{ fontWeight: "bold" }}>
                                  Insurance Company:{" "}
                                </label>{selectedVisit.insurancecompany}
                              </div>
                              <div>
                                <label style={{ fontWeight: "bold" }}>
                                  Eligibility Identifier:{" "}
                                </label>
                                {selectedVisit.eligibilityresponseidentifier}
                              </div>

                            </Col>
                          </Row>
                        </>
                      ) : null}

                      {this.state.approvalInfoExist ? (
                        <>
                          <hr />

                          <Row>
                            <Col sm={4}>
                              {selectedVisit.authorizationrequestidentifier ? (
                                <div>
                                  <label style={{ fontWeight: "bold" }}>
                                    Approval Request Identifier:{" "}
                                  </label>
                                  {selectedVisit.authorizationrequestidentifier}
                                </div>
                              ) : null}




                            </Col>
                            <Col sm={4}>
                              {selectedVisit.authorizationresponseidentifier ? (
                                <div>
                                  <label style={{ fontWeight: "bold" }}>
                                    Pre-Auth Response Identifier:{" "}
                                  </label>
                                  {selectedVisit.authorizationresponseidentifier}
                                </div>
                              ) : null}

                              {selectedVisit.preAuthRef ? (
                                <div>
                                  <label style={{ fontWeight: "bold" }}>
                                    Pre-Auth Reference(Approval Number):{" "}
                                  </label>
                                  {selectedVisit.preAuthRef}
                                </div>
                              ) : null}

                            </Col>
                            <Col sm={4}>
                              {selectedVisit["approvalAdudicationOutcome"] ? (
                                <div style={{ textTransform: "capitalize" }}>
                                  <label style={{ fontWeight: "bold" }}>
                                    Pre-Auth Adjudication Outcome:{" "}
                                  </label>
                                  {selectedVisit["approvalAdudicationOutcome"]}
                                </div>
                              ) : selectedVisit.authorizationstatus === "4" ? (
                                <div style={{ textTransform: "capitalize" }}>
                                  <label style={{ fontWeight: "bold" }}>
                                    Authorization Status:{" "}
                                  </label>
                                  Queued
                                </div>
                              ) : null}

                            </Col>
                          </Row>
                        </>
                      ) : null}

                      <hr />
                      <Row>
                        <Col>
                          {selectedVisit.claimsubmissionstatus ? (
                            <div
                            >
                              <label style={{ fontWeight: "bold" }}>
                                Claim Submission Status:{" "}
                              </label>
                              {selectedVisit.claimsubmissionstatus === "1" ? "Pending" :
                                selectedVisit.claimsubmissionstatus === "2" ? "Faild" :
                                  selectedVisit.claimsubmissionstatus === "3" ? "Complete" :
                                    selectedVisit.claimsubmissionstatus === "4" ? "Queued" :
                                      selectedVisit.claimsubmissionstatus === "cancelled" ? "Cancelled" : null}
                            </div>
                          ) : null}
                          {selectedVisit.claimrequestidentifier ? (<>
                            <div>
                              <label style={{ fontWeight: "bold" }}>
                                Claim Submission Request Identifier:{" "}
                              </label>
                              {selectedVisit.claimrequestidentifier}
                            </div>
                          </>) : null}


                        </Col>
                        <Col>
                          {selectedVisit.claimresponseidentifier ? (<>

                            <div>
                              <label style={{ fontWeight: "bold" }}>
                                Claim Submission Response Identifier:{" "}
                              </label>
                              {selectedVisit.claimresponseidentifier}
                            </div>
                          </>) : null}
                        </Col>
                        <Col>
                          {selectedVisit.SubmissionAdjudicationOutcome ? (

                            <div style={{ textTransform: "capitalize" }}>
                              <label style={{ fontWeight: "bold" }}>
                                Claim Submission Adjucation outcome:{" "}
                              </label>
                              {selectedVisit.SubmissionAdjudicationOutcome}
                            </div>
                          ) : null}
                        </Col>

                      </Row>

                      <Row>
                        <Col xs={6}>
                          {allDiagnosisRows && allDiagnosisRows.length > 0 ? (
                            <div
                              style={{
                                margin: "auto",
                                width: "80%",
                              }}
                            >
                              <TableContainer
                                component={Paper}
                                style={{ marginTop: "10px" }}
                              >
                                <Table aria-label="simple table">
                                  <TableHead
                                    style={{ backgroundColor: "#fafafa" }}
                                  >
                                    <TableRow>
                                      <TableCell align="center" colSpan={4}>
                                        Diagnosis
                                      </TableCell>
                                    </TableRow>
                                    <TableRow style={{ textAlign: "center" }}>
                                      <TableCell align="center">ID</TableCell>
                                      <TableCell align="center">Type</TableCell>
                                      <TableCell align="center">Code</TableCell>
                                      <TableCell align="center">
                                        Description
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>

                                  <TableBody>{allDiagnosisRows}</TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                          ) : null}
                        </Col>
                        <Col xs={6}>
                          {(supportingInformationTable &&
                            supportingInformationTable.length > 0) ||
                            this.state.addVital ? (
                            <>
                              <div style={{ margin: "auto" }}>
                                <TableContainer
                                  component={Paper}
                                  style={{ marginTop: "10px", width: "80%" }}
                                >
                                  <Table aria-label="simple table">
                                    <TableHead
                                      style={{ backgroundColor: "#fafafa" }}
                                    >
                                      <TableRow>
                                        <TableCell
                                          align="center"
                                          colSpan={editClaim ? 4 : 3}
                                        >
                                          Supporting Information
                                        </TableCell>
                                      </TableRow>
                                      {supportingInformationTable &&
                                        supportingInformationTable.length > 0 ? (
                                        <>
                                          <TableRow
                                            style={{ textAlign: "center" }}
                                          >
                                            <TableCell align="center">
                                              ID
                                            </TableCell>
                                            <TableCell align="center">
                                              Information
                                            </TableCell>
                                            <TableCell align="center">
                                              Value
                                            </TableCell>
                                            {editClaim ? (
                                              <TableCell align="center">
                                                Action
                                              </TableCell>
                                            ) : null}
                                          </TableRow>
                                        </>
                                      ) : null}
                                    </TableHead>

                                    <TableBody>
                                      {supportingInformationTable}
                                    </TableBody>
                                    {this.state.addVital ? (
                                      <>
                                        <TableRow
                                          style={{ backgroundColor: "#fafafa" }}
                                        >
                                          <TableCell align="center" colSpan={3}>
                                            Vital Sign
                                          </TableCell>
                                          <TableCell align="center">
                                            Add
                                          </TableCell>
                                        </TableRow>
                                        <TableRow>
                                          <TableCell
                                            align="center"
                                            colSpan={3}
                                            style={{ width: "45%" }}
                                          >
                                            <div style={{ textAlign: "center" }}>
                                              <FormControl
                                                style={{ width: "70%" }}
                                                sx={{ mb: 3 }}
                                              >
                                                <InputLabel
                                                  id="category"
                                                  style={{ fontSize: "small" }}
                                                >
                                                  Vital Sign
                                                </InputLabel>
                                                <Select
                                                  labelId="supportingInformation"
                                                  name="category"
                                                  label="supportingInformation"
                                                  onChange={
                                                    this.HandleVitalSignChange
                                                  }
                                                  value={this.state.vitalSelect}
                                                  style={{ height: "45px" }}
                                                >
                                                  <MenuItem
                                                    value="vital-sign-diastolic"
                                                    style={{ fontSize: "small" }}
                                                  >
                                                    Diastolic
                                                  </MenuItem>
                                                  <MenuItem
                                                    value="vital-sign-systolic"
                                                    style={{ fontSize: "small" }}
                                                  >
                                                    Systolic
                                                  </MenuItem>
                                                  <MenuItem
                                                    value="vital-sign-height"
                                                    style={{ fontSize: "small" }}
                                                  >
                                                    Height
                                                  </MenuItem>
                                                  <MenuItem
                                                    value="vital-sign-weight"
                                                    style={{ fontSize: "small" }}
                                                  >
                                                    Weight
                                                  </MenuItem>

                                                  <MenuItem
                                                    value="temperature"
                                                    style={{ fontSize: "small" }}
                                                  >
                                                    Temperature
                                                  </MenuItem>

                                                  <MenuItem
                                                    value="pulse"
                                                    style={{ fontSize: "small" }}
                                                  >
                                                    Pulse
                                                  </MenuItem>

                                                  <MenuItem
                                                    value="respiratory-rate"
                                                    style={{ fontSize: "small" }}
                                                  >
                                                    Respiratory Rate
                                                  </MenuItem>

                                                  <MenuItem
                                                    value="chief-complaint"
                                                    style={{ fontSize: "small" }}
                                                  >
                                                    Chief Complaint
                                                  </MenuItem>
                                                  <MenuItem
                                                    value="birth-weight"
                                                    style={{ fontSize: "small" }}
                                                  >
                                                    Birth weight
                                                  </MenuItem>
                                                  <MenuItem
                                                    value="attachment"
                                                    style={{ fontSize: "small" }}
                                                  >
                                                    Attachment
                                                  </MenuItem>
                                                </Select>
                                              </FormControl>
                                            </div>
                                            {this.state.chiefComplainSelected ? (
                                              <>
                                                <div
                                                  style={{ textAlign: "center" }}
                                                >
                                                  <FormControl
                                                    style={{ width: "70%" }}
                                                    sx={{ mb: 3 }}
                                                  >
                                                    <TextField
                                                      InputLabelProps={{
                                                        sx: { fontSize: "small" },
                                                      }}
                                                      value={
                                                        this.state.vitalValue
                                                      }
                                                      inputProps={{
                                                        sx: { padding: "11px" },
                                                      }}
                                                      required
                                                      type="text"
                                                      name={
                                                        this.state.selectedName
                                                      }
                                                      label={
                                                        this.state.selectedName
                                                      }
                                                      variant="outlined"
                                                      onChange={
                                                        this
                                                          .HandleSupportingInfoChange
                                                      }
                                                    />
                                                  </FormControl>
                                                </div>
                                                <div
                                                  style={{ textAlign: "center" }}
                                                >
                                                  <Button
                                                    variant="contained"
                                                    style={{
                                                      backgroundColor:
                                                        "rgb(97 110 120",
                                                      width: "100px",
                                                    }}
                                                    onClick={(e) =>
                                                      this.handleConfirm(e)
                                                    }
                                                  >
                                                    Add
                                                  </Button>
                                                </div>
                                              </>
                                            ) : this.state.attachmentSelected ? (
                                              <>
                                                <input
                                                  style={{
                                                    display: "block",
                                                    margin: "auto",
                                                    marginRight: "5px",
                                                  }}
                                                  type="file"
                                                  onChange={this.onFileChange}
                                                />
                                                {this.state.fileMsg ? (
                                                  <>
                                                    <div
                                                      style={{
                                                        textAlign: "center",
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          color: "red",
                                                          fontSize: "10px",
                                                        }}
                                                      >
                                                        {this.state.fileMsg}
                                                      </span>
                                                    </div>
                                                  </>
                                                ) : null}
                                              </>
                                            ) : this.state.vitalSignSelected ? (
                                              <>
                                                <div
                                                  style={{ textAlign: "center" }}
                                                >
                                                  <FormControl
                                                    style={{ width: "70%" }}
                                                    sx={{ mb: 3 }}
                                                  >
                                                    <TextField
                                                      InputLabelProps={{
                                                        sx: { fontSize: "small" },
                                                      }}
                                                      value={
                                                        this.state.vitalValue
                                                      }
                                                      inputProps={{
                                                        sx: { padding: "11px" },
                                                      }}
                                                      required
                                                      type="number"
                                                      name={
                                                        this.state.selectedName
                                                      }
                                                      label={
                                                        this.state.selectedName
                                                      }
                                                      variant="outlined"
                                                      onChange={
                                                        this
                                                          .HandleSupportingInfoChange
                                                      }
                                                    />
                                                  </FormControl>
                                                </div>
                                              </>
                                            ) : null}
                                          </TableCell>
                                          <TableCell
                                            align="center"
                                            style={{ width: "10%" }}
                                          >
                                            <a
                                              style={{
                                                display: "inline-block",
                                                marginBottom: "30px",
                                              }}
                                              onClick={(e) => {
                                                this.handleConfirm(e);
                                              }}
                                            >
                                              <AddCircleIcon
                                                style={{ cursor: "pointer" }}
                                              />
                                            </a>
                                          </TableCell>
                                        </TableRow>
                                      </>
                                    ) : null}
                                    {editClaim ? (
                                      <TableRow>
                                        <TableCell align="center" colSpan={4}>
                                          <Button
                                            style={{
                                              width: "10%",
                                              backgroundColor: "rgb(97 110 120",
                                              border: "1px ridge gray",
                                              color: "white",
                                              fontSize: "smaller",
                                            }}
                                            onClick={(e) => {
                                              this.setState({
                                                addVital: "true",
                                              });
                                            }}
                                          >
                                            <AddCircleIcon />
                                          </Button>
                                        </TableCell>
                                      </TableRow>
                                    ) : null}
                                  </Table>
                                </TableContainer>
                              </div>
                            </>
                          ) : null}
                        </Col>
                      </Row>

                      {allproceduresRows && allproceduresRows.length > 0 ? (
                        <>
                          <hr />
                          <div style={{ width: "100%", margin: "auto" }}>
                            <a style={{ cursor: "pointer", textDecoration: 'underline', fontWeight: "bold" }} onClick={(e) => {
                              if (!this.state.editProcedure) {
                                this.setState({ editProcedure: true });
                              } else {
                                this.setState({ editProcedure: false });

                              }
                            }}>{!this.state.editProcedure ? 'Edit Included Procedure' : 'Save'}</a>
                            <TableContainer
                              component={Paper}
                              style={{
                                marginTop: "10px",
                                width: "100%",
                                fontSize: "small",
                              }}
                            >
                              <Table aria-label="simple table">
                                <TableHead
                                  style={{
                                    backgroundColor: "#fafafa",
                                    fontSize: "small",
                                  }}
                                >
                                  <TableRow style={{ fontSize: "small" }}>
                                    <TableCell align="center">
                                      <Checkbox
                                        checked={this.state.allproceduresFlag ? true : false}
                                        disabled={this.state.editProcedure ? false : true}
                                        name="allProcedures"
                                        onChange={(e) =>
                                          this.handleCheckBoxChange(e)
                                        }
                                      />
                                    </TableCell>

                                    <TableCell align="center">
                                      Type
                                    </TableCell>
                                    <TableCell align="center">
                                      Code
                                    </TableCell>
                                    <TableCell align="center">
                                      Description
                                    </TableCell>
                                    <TableCell align="center">
                                      Invoice Number
                                    </TableCell>
                                    <TableCell align="center">
                                      Quantity
                                    </TableCell>

                                    {this.state.showToothNumber ? (
                                      <TableCell align="center">
                                        Tooth Number
                                      </TableCell>
                                    ) : null}
                                    <TableCell align="center">
                                      Unit Price
                                    </TableCell>
                                    <TableCell align="center">
                                      Discount
                                    </TableCell>
                                    <TableCell align="center">
                                      Tax
                                    </TableCell>

                                    <TableCell align="center">
                                      Deduction(%)
                                    </TableCell>

                                    <TableCell align="center">
                                      Patient Share
                                    </TableCell>
                                    <TableCell align="center">
                                      Net
                                    </TableCell>
                                    <TableCell align="center">
                                      Tooth
                                    </TableCell>
                                    <TableCell align="center">
                                      Related Diagnosis
                                    </TableCell>

                                    <TableCell align="center">
                                      Related Information Sequence
                                    </TableCell>

                                    {selectedVisit.authorizationstatus &&
                                      selectedVisit.authorizationstatus == "3" ? (
                                      <TableCell
                                        align="center"
                                      >
                                        Pre-Approval Response
                                      </TableCell>
                                    ) : null}

                                    {selectedVisit.claimsubmissionstatus &&
                                      selectedVisit.claimsubmissionstatus ==
                                      "3" || (selectedVisit.claimsubmissionstatus == "cancelled" && this.state.errorsRow.length == 0 && !this.state.queuedFlag) ? (
                                      <TableCell
                                        align="center"
                                      >
                                        Submission Response
                                      </TableCell>
                                    ) : null}
                                  </TableRow>
                                </TableHead>
                                <TableBody style={{ fontSize: "small" }}>
                                  {allproceduresRows}
                                </TableBody>
                                <TableRow>
                                  <TableCell
                                    colSpan={
                                      selectedVisit.approvalAdudicationOutcome
                                        ? 14
                                        : 12
                                    }
                                  >
                                    Claim Total Net : {parseFloat(totalSum).toFixed(2)}{" SAR"}

                                  </TableCell>
                                </TableRow>

                              </Table>
                            </TableContainer>
                          </div>
                        </>
                      ) : null}
                      <Row>
                        <Col xs={6}>
                          {selectedVisit.Authtotals && AuthtotalRows && AuthtotalRows.length > 0 ? (
                            <div style={{ width: "50%", margin: "10px auto" }}>
                              <h4 style={{ textAlign: "center" }}>Authorization Total</h4>
                              <TableContainer
                                component={Paper}
                                style={{
                                  margin: "10px auto",
                                  width: "100%",
                                }}
                              >
                                <Table aria-label="simple table">
                                  <TableHead style={{ backgroundColor: "#fafafa" }}>
                                    <TableRow style={{ textAlign: "center" }}>
                                      <TableCell align="center">Category</TableCell>
                                      <TableCell align="center">Amount</TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {AuthtotalRows}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                          ) : null}
                        </Col>
                        <Col xs={6}>
                          {selectedVisit.totals && totalRows && totalRows.length > 0 || (selectedVisit.claimsubmissionstatus == "cancelled" && this.state.errorsRow.length == 0 && !this.state.queuedFlag) ? (
                            <div style={{ width: "50%", margin: "10px auto" }}>
                              <h4 style={{ textAlign: "center" }}>Claim Total</h4>
                              <TableContainer
                                component={Paper}
                                style={{
                                  margin: "10px auto",
                                  width: "100%",
                                }}
                              >
                                <Table aria-label="simple table">
                                  <TableHead style={{ backgroundColor: "#fafafa" }}>
                                    <TableRow style={{ textAlign: "center" }}>
                                      <TableCell align="center">Category</TableCell>
                                      <TableCell align="center">Amount</TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {totalRows}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                          ) : null}
                        </Col>
                      </Row>
                      {this.state.AuthQueuedInfo && selectedVisit.authorizationstatus == "4" ? (
                        <>
                          <h4 style={{ textAlign: "center" }}>Queued Info For Authorization </h4>
                          <div
                            style={{
                              width: "100%",
                              margin: "auto",
                              paddingBottom: "20px",
                            }}
                          >
                            <TableContainer
                              component={Paper}
                              style={{
                                margin: "auto",
                                marginTop: "30px",
                                width: "100%",
                              }}
                            >
                              <Table aria-label="simple table">
                                <TableHead style={{ backgroundColor: "#fafafa" }}>
                                  <TableRow style={{ textAlign: "center" }}>
                                    <TableCell align="center">Outcome</TableCell>
                                    <TableCell align="center">
                                      Bundle ID
                                    </TableCell>
                                    <TableCell align="center">
                                      Request Identifier
                                    </TableCell>
                                    <TableCell align="center">
                                      Pre Authorization Response Identifier
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  <TableRow>
                                    <TableCell
                                      align="center"
                                      style={{ fontSize: "small" }}
                                    >
                                      {this.state.AuthQueuedInfo.outcome}
                                    </TableCell>
                                    <TableCell
                                      align="center"
                                      style={{ fontSize: "small" }}
                                    >
                                      The Calim Submission for the selected
                                      activities is qeued , try to pull the
                                      response anothertime ,and the bundle ID is
                                      {this.state.AuthQueuedInfo.bundleID}
                                    </TableCell>
                                    <TableCell
                                      align="center"
                                      style={{ fontSize: "small" }}
                                    >
                                      {this.state.AuthQueuedInfo.requestIdentifier}
                                    </TableCell>

                                    <TableCell
                                      align="center"
                                      style={{ fontSize: "small" }}
                                    >
                                      {
                                        this.state.AuthQueuedInfo
                                          .preAuthResponseIdentifier
                                      }
                                    </TableCell>
                                  </TableRow>
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </div>
                        </>
                      ) : null}
                      {(selectedVisit.claimsubmissionstatus &&
                        selectedVisit.claimsubmissionstatus == "4") &&
                        this.state.queuedInfo
                        || (selectedVisit.claimsubmissionstatus == "cancelled" && totalRows.length == 0 && this.state.errorsRow.length == 0 && selectedVisit.claimresponseoutcome === "queued")
                        ? (
                          <>
                            <h4 style={{ textAlign: "center" }}>Queued Info For Claim Submission </h4>
                            <div
                              style={{
                                width: "100%",
                                margin: "auto",
                                paddingBottom: "20px",
                              }}
                            >
                              <TableContainer
                                component={Paper}
                                style={{
                                  margin: "auto",
                                  marginTop: "30px",
                                  width: "100%",
                                }}
                              >
                                <Table aria-label="simple table">
                                  <TableHead style={{ backgroundColor: "#fafafa" }}>
                                    <TableRow style={{ textAlign: "center" }}>
                                      <TableCell align="center">Outcome</TableCell>
                                      <TableCell align="center">
                                        Bundle ID
                                      </TableCell>
                                      <TableCell align="center">
                                        Request Identifier
                                      </TableCell>
                                      <TableCell align="center">
                                        Claim Submission Response Identifier
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    <TableRow>
                                      <TableCell
                                        align="center"
                                        style={{ fontSize: "small" }}
                                      >
                                        {this.state.queuedInfo.outcome}
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{ fontSize: "small" }}
                                      >
                                        The Calim Submission for the selected
                                        activities is qeued , try to pull the
                                        response anothertime ,and the bundle ID is
                                        {this.state.queuedInfo.bundleID}
                                      </TableCell>
                                      <TableCell
                                        align="center"
                                        style={{ fontSize: "small" }}
                                      >
                                        {this.state.queuedInfo.requestIdentifier}
                                      </TableCell>

                                      <TableCell
                                        align="center"
                                        style={{ fontSize: "small" }}
                                      >
                                        {
                                          this.state.queuedInfo
                                            .claimResponseIdentifier
                                        }
                                      </TableCell>
                                    </TableRow>
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                          </>
                        ) : null}
                      {(selectedVisit.claimsubmissionstatus &&
                        selectedVisit.claimsubmissionstatus == "2") &&
                        this.state.errorsRow &&
                        this.state.errorsRow.length > 0 || (selectedVisit.claimsubmissionstatus == "cancelled" && totalRows.length == 0 && !this.state.queuedFlag) ? (
                        <>
                          <Typography
                            id="modal-modal-title"
                            variant="h6"
                            component="h2"
                            style={{ textAlign: "center", marginTop: "10px" }}
                          >
                            Errors
                          </Typography>
                          <div
                            style={{
                              width: "100%",
                              margin: "auto",
                              paddingBottom: "20px",
                            }}
                          >
                            <TableContainer
                              component={Paper}
                              style={{
                                margin: "auto",
                                marginTop: "30px",
                                width: "100%",
                              }}
                            >
                              <Table aria-label="simple table">
                                <TableHead style={{ backgroundColor: "#fafafa" }}>
                                  <TableRow style={{ textAlign: "center" }}>
                                    <TableCell align="center">
                                      Error Code
                                    </TableCell>
                                    <TableCell align="center">
                                      Error Display
                                    </TableCell>
                                    <TableCell align="center">
                                      Error Extention
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>{this.state.errorsRow}</TableBody>
                              </Table>
                            </TableContainer>
                          </div>
                        </>
                      ) : null}
                      {this.state.checkStatusFlag ? (<>
                        <Stack style={{ position: 'fixed', top: 10, right: 10, zIndex: 9999, textTransform: "capitalize" }}>
                          <Alert severity="info">
                            {this.state.valueCode ? this.state.valueCode : this.state.statusErrors[0].errorMsg}
                          </Alert>
                        </Stack>
                      </>) : null}
                      {this.state.cancelError ? (
                      <>
                        <Stack
                          style={{
                            position: "fixed",
                            top: 10,
                            right: 10,
                            zIndex: 9999,
                            textTransform: "capitalize",
                          }}
                        >
                          <Alert severity="info">
                            {this.state.cancelError}
                          </Alert>
                        </Stack>
                      </>
                    ) : null}
                      {this.state.invoiceMsg ? (<>
                        <Stack style={{ position: 'fixed', top: 10, right: 10, zIndex: 9999, textTransform: "capitalize" }}>
                          <Alert severity="error">
                            {this.state.invoiceMsg}
                          </Alert>
                        </Stack>
                      </>) : null}

                      {this.state.submissionError ? (<>
                        <Stack style={{ position: 'fixed', top: 10, right: 10, zIndex: 9999, textTransform: "capitalize" }}>
                          <Alert severity="error">
                            {this.state.submissionError}
                          </Alert>
                        </Stack>
                      </>) : null}
                      {/*    {this.state.TableOfBenefitsForView &&
                      this.state.TableOfBenefitsForView.length > 0 ? (
                        <>
                          <Typography
                            id="modal-modal-title"
                            variant="h6"
                            component="h2"
                            sx={{ mt: 2 }}
                            style={{ textAlign: "center" }}
                          >
                            Active Policies
                          </Typography>
                          <TableContainer
                            component={Paper}
                            style={{ marginTop: "20px" }}
                          >
                            <Table
                              sx={{ minWidth: 650 }}
                              aria-label="simple table"
                            >
                              <TableHead style={{ backgroundColor: "#fafafa" }}>
                                <TableRow style={{ textAlign: "center" }}>
                                  <TableCell align="center">ID</TableCell>
                                  <TableCell align="center">
                                    Site Eligibility
                                  </TableCell>
                                  <TableCell align="center">Inforce</TableCell>
                                  <TableCell align="center">Coverage</TableCell>
                                  {this.state.itemsOfInsurance &&
                                  this.state.itemsOfInsurance.length > 0 ? (
                                    <TableCell align="center">Items</TableCell>
                                  ) : null}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {this.state.TableOfBenefitsForView}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </>
                      ) : null} */}
                      {/* <hr />

                      {this.state.claimSubmissionItemsRows &&
                        this.state.claimSubmissionItemsRows.length > 0 ? (
                        <>
                          <Typography
                            id="modal-modal-title"
                            variant="h6"
                            component="h2"
                            style={{ textAlign: "center" }}
                          >
                            Adjudication OutCome :{this.state.adjucationoutcome}
                          </Typography>
                          <TableContainer
                            component={Paper}
                            style={{
                              margin: "auto",
                              marginTop: "30px",
                              width: "100%",
                            }}
                          >
                            <Table aria-label="simple table">
                              <TableHead style={{ backgroundColor: "#fafafa" }}>
                                <TableRow style={{ textAlign: "center" }}>
                                  <TableCell align="center">Items</TableCell>
                                  <TableCell align="center">Outcome</TableCell>
                                  {this.state.adjucationoutcome == "rejected" ||
                                    this.state.adjucationoutcome == "partial" ? (
                                    <>
                                      <TableCell align="center">
                                        Reason
                                      </TableCell>
                                      <TableCell align="center">
                                        Denail Code
                                      </TableCell>
                                    </>
                                  ) : null}
                                  <TableCell align="center">
                                    Adjudication
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {this.state.claimSubmissionItemsRows}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </>
                      ) : null} */}

                      {/*  {errorsRow && errorsRow.length > 0 ? (
                        <>
                          <Typography
                            id="modal-modal-title"
                            variant="h6"
                            component="h2"
                            style={{ textAlign: "center", marginTop: "10px" }}
                          >
                            Errors
                          </Typography>
                          <div
                            style={{
                              width: "100%",
                              margin: "auto",
                              paddingBottom: "20px",
                            }}
                          >
                            <TableContainer
                              component={Paper}
                              style={{
                                margin: "auto",
                                marginTop: "30px",
                                width: "100%",
                              }}
                            >
                              <Table aria-label="simple table">
                                <TableHead
                                  style={{ backgroundColor: "#fafafa" }}
                                >
                                  <TableRow style={{ textAlign: "center" }}>
                                    <TableCell align="center">
                                      Error Code
                                    </TableCell>
                                    <TableCell align="center">
                                      Error Display
                                    </TableCell>
                                    <TableCell align="center">
                                      Error Extention
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>{errorsRow}</TableBody>
                              </Table>
                            </TableContainer>
                          </div>
                        </>
                      ) : this.state.queuedInfoRows ? (
                        <div
                          style={{
                            width: "85%",
                            margin: "auto",
                            paddingBottom: "20px",
                          }}
                        >
                          <TableContainer
                            component={Paper}
                            style={{
                              margin: "auto",
                              marginTop: "30px",
                              width: "100%",
                            }}
                          >
                            <Table aria-label="simple table">
                              <TableHead style={{ backgroundColor: "#fafafa" }}>
                                <TableRow style={{ textAlign: "center" }}>
                                  <TableCell align="center">Outcome</TableCell>
                                  <TableCell align="center">
                                    Bundle Id
                                  </TableCell>
                                  <TableCell align="center">
                                    Request Identifier
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>{this.state.queuedInfoRows}</TableBody>
                            </Table>
                          </TableContainer>
                        </div>
                      ) : null} */}
                    </Box>
                  </Modal>
                </>
              ) : null}
              {/*    {this.state.showCoverageInfo ? (
                <>
                  <Modal
                    open={this.state.showCoverageInfo}
                    onClose={this.handleCloseCoverageInfoModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <Box
                      sx={style}
                      style={{
                        width: "30%",
                        height: "500px",
                        overflowY: "scroll",
                      }}
                    >
                      <Typography
                        id="modal-modal-title"
                        variant="h6"
                        component="h2"
                        style={{ textAlign: "center" }}
                      >
                        Coverage Information
                      </Typography>
                      <Typography id="modal-modal-title" sx={{ mt: 2 }}>
                        Member ID:{this.state.memberid}
                      </Typography>
                      <Typography
                        id="modal-modal-title"
                        sx={{ mt: 2 }}
                        style={{ textTransform: "capitalize" }}
                      >
                        Coverage Type:{this.state.coverageType}
                      </Typography>
                      <Typography
                        id="modal-modal-title"
                        sx={{ mt: 2 }}
                        style={{ textTransform: "capitalize" }}
                      >
                        Network:{this.state.network}
                      </Typography>
                      <Typography
                        id="modal-modal-title"
                        sx={{ mt: 2 }}
                        style={{ textTransform: "capitalize" }}
                      >
                        Term:{this.state.term}
                      </Typography>
                      <Typography
                        id="modal-modal-title"
                        sx={{ mt: 2 }}
                        style={{ textTransform: "capitalize" }}
                      >
                        subscriber Relationship:
                        {this.state.subscriberRelationship}
                      </Typography>
                      {this.state.costToBeneficiaryTypesValues &&
                      this.state.costToBeneficiaryTypesValues.length > 0 ? (
                        <>{costRows}</>
                      ) : null}
                      <Typography
                        id="modal-modal-title"
                        sx={{ mt: 2 }}
                        style={{
                          textTransform: "capitalize",
                          textAlign: "center",
                        }}
                      >
                        Classes
                      </Typography>
                      <TableContainer
                        component={Paper}
                        style={{ marginTop: "20px" }}
                      >
                        <Table sx={{ minWidth: 100 }} aria-label="simple table">
                          <TableHead style={{ backgroundColor: "#fafafa" }}>
                            <TableRow style={{ textAlign: "center" }}>
                              <TableCell align="center">Type</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="center">Value</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>{classRows}</TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                  </Modal>
                </>
              ) : null} */}
            </div>
          </div>
        </div>
      </Box>
    );
  }
}

export default ClaimSubmission;
